<template>
  <div>
    <v-container fluid width="100%" height="100%">
      <v-layout row wrap class="ma-0">
        <v-flex xs12 sm12 md5 lg4>
          <!-- <v-card class="ma-1" max-height="60%" max-width="700px" flat> -->
          <v-form ref="form" @submit.prevent>
            <v-container fluid class="ma-1 pa-0">
              <v-card
                class="ma-1 pa-0"
                dense
                width="90%"
                height="90%"
                style="border: 2px solid black; width: auto;  overflow:auto;"
                color="#E8E8E8"
              >
                <v-card-title
                  >DEMAND <span class="red--text">FORM</span></v-card-title
                >
                <v-select
                  class="ma-2"
                  clearable
                  dense
                  filled
                  color="#2E5473"
                  outlined
                  label="VIEW PRIOR DEMANDS"
                  :items="priorDemands"
                  item-text="name"
                  return-object
                  v-model="selectedPriorDemand"
                  disabled
                ></v-select>
                <!-- BASIC DEMAND INFORMATION -->
                <v-card
                  style="border: 2px solid black; width: auto;  overflow:auto;"
                  class="ma-1"
                  dense
                  width="90%"
                >
                  <v-container fluid>
                    <v-card-text class="title">
                      <v-row>
                        <div>BASIC DEMAND INFORMATION</div>
                        <v-spacer></v-spacer>
                        <v-btn
                          rounded
                          small
                          text
                          class="red--text"
                          @click="editBasicInfo = false"
                          v-if="editBasicInfo"
                          >DONE</v-btn
                        >
                        <v-btn
                          class="ma-1"
                          text
                          small
                          rounded
                          outlined
                          color="orange darken-3"
                          @click="editBasicInfo = true"
                          v-if="!editBasicInfo"
                          >EDIT</v-btn
                        ></v-row
                      >
                    </v-card-text>
                    <v-expand-transition>
                      <div v-if="editBasicInfo">
                        <!-- DATE -->
                        <v-autocomplete
                          class="ma-2"
                          clearable
                          dense
                          filled
                          color="#2E5473"
                          outlined
                          label="SELECT LAW FIRM"
                          v-model="selectedFirm"
                          :items="matter.firms"
                          item-text="firmName"
                          return-object
                        ></v-autocomplete>
                        <v-expand-transition>
                          <div v-if="selectedFirm">
                            <v-text-field
                              dense
                              label="DOCUMENT DATE"
                              v-model="docDate"
                              outlined
                              color="#2E5473"
                            ></v-text-field>

                            <!-- TITLE -->
                            <v-text-field
                              label="DOCUMENT TITLE"
                              v-model="docTitle"
                              outlined
                              dense
                              filled
                              color="#2E5473"
                            ></v-text-field>
                            <!-- CLAIMANT NAME -->
                            <v-text-field
                              label="Claimant's Full Name"
                              v-model="plaintiff.fullName"
                              dense
                              filled
                              color="#2E5473"
                            ></v-text-field>
                            <!-- DOL -->
                            <v-text-field
                              label="DATE OF LOSS"
                              v-model="matter.dateOfLoss"
                              dense
                              filled
                              color="#2E5473"
                            ></v-text-field>
                            <v-btn
                              rounded
                              small
                              text
                              class="red--text"
                              @click="editBasicInfo = false"
                              v-if="editBasicInfo"
                              >DONE</v-btn
                            >
                          </div>
                        </v-expand-transition>
                      </div>
                    </v-expand-transition>
                  </v-container>
                </v-card>
                <!-- DEMAND TYPE -->
                <v-card
                  style="border: 2px solid black; width: auto;  overflow:auto;"
                  class="ma-1"
                  dense
                  width="90%"
                >
                  <v-container fluid>
                    <v-card-text class="title">
                      <v-row>
                        <div>
                          DEMAND TYPE
                        </div>
                        <v-spacer></v-spacer>
                        <v-btn
                          rounded
                          small
                          text
                          class="red--text"
                          @click="editDemandType = false"
                          v-if="editDemandType"
                          >DONE</v-btn
                        >
                        <v-btn
                          class="ma-1"
                          text
                          small
                          rounded
                          outlined
                          color="orange darken-3"
                          @click="editDemandType = true"
                          v-if="!editDemandType"
                          >EDIT</v-btn
                        ></v-row
                      >
                    </v-card-text>

                    <v-expand-transition>
                      <div v-if="editDemandType">
                        <v-radio-group
                          v-model="demandType"
                          v-for="(dem, i) in demandTypeOptions"
                          :key="i"
                          @change="reloadDoc"
                        >
                          <v-radio :label="dem" :value="dem"></v-radio>
                        </v-radio-group>
                        <v-text-field
                          dense
                          filled
                          color="#2E5473"
                          label="TIME LIMIT (DAYS)"
                          type="number"
                          v-model="timeLimit"
                        ></v-text-field>
                        <v-expand-transition>
                          <v-text-field
                            v-if="demandType === 'STANDARD DEMAND'"
                            dense
                            filled
                            color="#2E5473"
                            label="AMOUNT BEING DEMANDED"
                            v-model="demandAmount"
                          ></v-text-field>
                        </v-expand-transition>
                        <v-expand-transition>
                          <v-card
                            style=" width: auto;  overflow:auto;"
                            class="ma-2"
                            dense
                            width="90%"
                            v-if="demandType === 'UIM POLICY LIMIT DEMAND'"
                            color="#E8E8E8"
                          >
                            <v-container fluid>
                              <div v-if="plaintiff && plaintiff.insurance">
                                <v-expand-transition>
                                  <div>
                                    <v-autocomplete
                                      dense
                                      @blur="reloadDoc"
                                      outlined
                                      color="#2E5473"
                                      label="SELECT AN EXISTING INSURANCE PROVIDER"
                                      clearable
                                      :items="plaintiff.insurance"
                                      item-text="name"
                                      return-object
                                      v-model="selectedProvider"
                                    ></v-autocomplete>
                                    <v-expand-transition>
                                      <v-card
                                        style="border: 2px solid black; width: auto;  overflow:auto;"
                                        class="ma-2"
                                        dense
                                        width="90%"
                                        v-if="selectedProvider"
                                      >
                                        <v-container fluid>
                                          <v-card-title
                                            >EXISTING 1ST PARTY INSURANCE
                                            INFORMATION</v-card-title
                                          >
                                          <v-text-field
                                            dense
                                            v-model="selectedProvider.name"
                                            label="PROVIDER NAME"
                                            outlined
                                          ></v-text-field>
                                          <v-text-field
                                            dense
                                            v-model="
                                              selectedProvider.streetAddress
                                            "
                                            label="PROVIDER STREET ADDRESS"
                                            outlined
                                          ></v-text-field>
                                          <v-text-field
                                            dense
                                            v-model="
                                              selectedProvider.cityStateZip
                                            "
                                            label="PROVIDER CITY, STATE AND ZIP"
                                            outlined
                                          ></v-text-field>
                                          <v-text-field
                                            dense
                                            v-model="
                                              selectedProvider.policyNumber
                                            "
                                            label="POLICY NUMBER"
                                            outlined
                                          ></v-text-field>
                                          <v-text-field
                                            dense
                                            v-model="
                                              selectedProvider.claimNumber
                                            "
                                            label="CLAIM NUMBER"
                                            outlined
                                          ></v-text-field>

                                          <v-text-field
                                            dense
                                            v-model="
                                              selectedProvider.adjusterName
                                            "
                                            label="ADJUSTER NAME"
                                            outlined
                                          ></v-text-field>
                                          <v-text-field
                                            dense
                                            v-model="
                                              selectedProvider.adjusterEmail
                                            "
                                            label="ADJUSTER EMAIL"
                                            outlined
                                            :rules="[rules.email]"
                                          ></v-text-field>
                                          <v-text-field
                                            dense
                                            v-model="
                                              selectedProvider.adjusterPhone
                                            "
                                            label="ADJUSTER PHONE"
                                            outlined
                                            v-mask="mask"
                                          ></v-text-field>
                                        </v-container>
                                        <v-card-actions
                                          ><v-spacer> </v-spacer
                                          ><v-btn
                                            rounded
                                            small
                                            text
                                            class="red--text"
                                            @click="editDemandType = false"
                                            v-if="editDemandType"
                                            >DONE</v-btn
                                          ></v-card-actions
                                        >
                                      </v-card>
                                    </v-expand-transition>
                                  </div>
                                </v-expand-transition>
                              </div>
                            </v-container>
                            <div v-if="plaintiff && !selectedProvider">
                              <v-card
                                style="border: 2px solid black; width: auto;  overflow:auto;"
                                class="ma-2"
                                dense
                                width="90%"
                              >
                                <v-container fluid>
                                  <v-card-title>
                                    PLAINTIFF INSURANCE INFORMATION
                                  </v-card-title>
                                  <v-text-field
                                    dense
                                    v-model="plaintiffInsuranceName"
                                    label="PROVIDER NAME"
                                    outlined
                                  ></v-text-field>
                                  <v-text-field
                                    dense
                                    v-model="plaintiffInsuranceStreetAddress"
                                    label="PROVIDER STREET ADDRESS"
                                    outlined
                                  ></v-text-field>
                                  <v-text-field
                                    dense
                                    v-model="plaintiffInsuranceCityStateZip"
                                    label="PROVIDER CITY, STATE AND ZIP"
                                    outlined
                                  ></v-text-field>
                                  <v-text-field
                                    dense
                                    v-model="plaintiffInsurancePolicyNumber"
                                    label="POLICY NUMBER"
                                    outlined
                                  ></v-text-field>
                                  <v-text-field
                                    dense
                                    v-model="plaintiffInsuranceClaimNumber"
                                    label="CLAIM NUMBER"
                                    outlined
                                  ></v-text-field>
                                  <v-text-field
                                    dense
                                    v-model="plaintiffInsuranceAdjusterName"
                                    label="ADJUSTER NAME"
                                    outlined
                                  ></v-text-field>
                                  <v-text-field
                                    dense
                                    v-model="plaintiffInsuranceAdjusterEmail"
                                    label="ADJUSTER EMAIL"
                                    outlined
                                    color="#2E5473"
                                    :rules="[rules.email]"
                                  ></v-text-field>
                                  <v-text-field
                                    dense
                                    v-model="plaintiffInsuranceAdjusterPhone"
                                    label="ADJUSTER PHONE"
                                    outlined
                                    color="#2E5473"
                                    v-mask="mask"
                                  ></v-text-field>
                                </v-container>
                                <v-card-actions>
                                  <v-btn
                                    rounded
                                    color="green"
                                    @click="savePlaintiffInsuranceToMatter"
                                    >save to matter</v-btn
                                  >
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    rounded
                                    small
                                    text
                                    class="red--text"
                                    @click="editDemandType = false"
                                    v-if="editDemandType"
                                    >DONE</v-btn
                                  >
                                </v-card-actions>
                              </v-card>
                            </div>
                          </v-card>
                        </v-expand-transition>
                      </div>
                    </v-expand-transition>
                    <v-btn
                      rounded
                      small
                      text
                      class="red--text"
                      @click="editDemandType = false"
                      v-if="editDemandType"
                      >DONE</v-btn
                    >
                  </v-container>
                </v-card>
                <!-- SELECT DEFENDANT CARD  -->
                <v-card
                  style="border: 2px solid black; width: auto;  overflow:auto;"
                  class="ma-1"
                  dense
                  width="90%"
                  v-if="demandType !== 'UIM POLICY LIMIT DEMAND'"
                >
                  <v-container fluid>
                    <v-card-text class="title">
                      <v-row>
                        <div>SELECT A DEFENDANT</div>
                        <v-spacer></v-spacer>
                        <v-btn
                          rounded
                          small
                          text
                          class="red--text"
                          @click="selectDefendant = false"
                          v-if="selectDefendant"
                          >DONE</v-btn
                        >
                        <v-btn
                          class="ma-1"
                          text
                          small
                          rounded
                          outlined
                          color="orange darken-3"
                          @click="selectDefendant = true"
                          v-if="!selectDefendant"
                          >EDIT</v-btn
                        ></v-row
                      >
                    </v-card-text>

                    <v-expand-transition>
                      <div v-if="selectDefendant">
                        <v-autocomplete
                          dense
                          @blur="reloadDoc"
                          label="TYPE OR SELECT"
                          v-model="defendant"
                          outlined
                          color="#2E5473"
                          filled
                          :items="defendantList"
                          item-text="fullName"
                          return-object
                          clearable
                        ></v-autocomplete>

                        <!-- DEFENDANT INSURANCE PROVIDER DETAILS  -->
                        <div v-if="defendant && defendant.insurance">
                          <v-expand-transition>
                            <v-card
                              style=" width: auto;  overflow:auto;"
                              class="ma-2"
                              dense
                              width="90%"
                              v-if="demandType !== 'UIM POLICY LIMIT DEMAND'"
                              color="#E8E8E8"
                            >
                              <v-container fluid>
                                <v-autocomplete
                                  dense
                                  @blur="reloadDoc"
                                  outlined
                                  color="#2E5473"
                                  filled
                                  label="SELECT AN EXISTING INSURANCE PROVIDER"
                                  clearable
                                  :items="defendant.insurance"
                                  item-text="name"
                                  return-object
                                  v-model="selectedProvider"
                                ></v-autocomplete>
                                <v-expand-transition>
                                  <v-card
                                    style="border: 2px solid black; width: auto;  overflow:auto;"
                                    class="ma-2"
                                    dense
                                    width="90%"
                                    v-if="selectedProvider"
                                  >
                                    <v-container fluid>
                                      <v-card-title
                                        >EXISTING DEFENDANT INSURANCE
                                        INFORMATION</v-card-title
                                      >
                                      <v-text-field
                                        dense
                                        v-model="selectedProvider.name"
                                        label="PROVIDER NAME"
                                        outlined
                                        color="#2E5473"
                                      ></v-text-field>
                                      <v-text-field
                                        dense
                                        v-model="selectedProvider.streetAddress"
                                        label="PROVIDER STREET ADDRESS"
                                        outlined
                                        color="#2E5473"
                                        filled
                                      ></v-text-field>
                                      <v-text-field
                                        dense
                                        v-model="selectedProvider.cityStateZip"
                                        label="PROVIDER CITY, STATE AND ZIP"
                                        outlined
                                        color="#2E5473"
                                        filled
                                      ></v-text-field>
                                      <v-text-field
                                        dense
                                        v-model="selectedProvider.policyNumber"
                                        label="POLICY NUMBER"
                                        outlined
                                        color="#2E5473"
                                        filled
                                      ></v-text-field>
                                      <v-text-field
                                        dense
                                        v-model="selectedProvider.claimNumber"
                                        label="CLAIM NUMBER"
                                        outlined
                                        color="#2E5473"
                                        filled
                                      ></v-text-field>

                                      <v-text-field
                                        dense
                                        v-model="selectedProvider.adjusterName"
                                        label="ADJUSTER NAME"
                                        outlined
                                        color="#2E5473"
                                        filled
                                      ></v-text-field>
                                      <v-text-field
                                        dense
                                        v-model="selectedProvider.adjusterEmail"
                                        label="ADJUSTER EMAIL"
                                        outlined
                                        color="#2E5473"
                                        filled
                                        :rules="[rules.email]"
                                      ></v-text-field>
                                      <v-text-field
                                        dense
                                        v-model="selectedProvider.adjusterPhone"
                                        label="ADJUSTER PHONE"
                                        outlined
                                        color="#2E5473"
                                        filled
                                        v-mask="mask"
                                      ></v-text-field>
                                    </v-container>
                                    <v-card-actions
                                      ><v-spacer> </v-spacer>
                                      <v-btn
                                        rounded
                                        small
                                        text
                                        class="red--text"
                                        @click="selectDefendant = false"
                                        v-if="selectDefendant"
                                        >DONE</v-btn
                                      >
                                    </v-card-actions>
                                  </v-card>
                                </v-expand-transition>
                              </v-container>
                            </v-card>
                          </v-expand-transition>
                        </div>
                        <div v-if="defendant && !selectedProvider">
                          <v-card
                            sstyle="border: 2px solid black; width: auto;  overflow:auto;"
                            class="ma-2"
                            dense
                            width="90%"
                          >
                            <v-container fluid>
                              <v-card-title
                                >NEW DEFENDANT INSURANCE
                                INFORMATION</v-card-title
                              >
                              <v-text-field
                                dense
                                v-model="defendantInsuranceName"
                                label="PROVIDER NAME"
                                outlined
                                color="#2E5473"
                              ></v-text-field>
                              <v-text-field
                                dense
                                v-model="defendantInsuranceStreetAddress"
                                label="PROVIDER STREET ADDRESS"
                                outlined
                                color="#2E5473"
                              ></v-text-field>
                              <v-text-field
                                dense
                                v-model="defendantInsuranceCityStateZip"
                                label="PROVIDER CITY, STATE AND ZIP"
                                outlined
                                color="#2E5473"
                              ></v-text-field>
                              <v-text-field
                                dense
                                v-model="defendantInsurancePolicyNumber"
                                label="POLICY NUMBER"
                                outlined
                                color="#2E5473"
                              ></v-text-field>
                              <v-text-field
                                dense
                                v-model="defendantInsuranceClaimNumber"
                                label="CLAIM NUMBER"
                                outlined
                                color="#2E5473"
                              ></v-text-field>

                              <v-text-field
                                dense
                                v-model="defendantInsuranceAdjusterName"
                                label="ADJUSTER NAME"
                                outlined
                                color="#2E5473"
                              ></v-text-field>
                              <v-text-field
                                dense
                                v-model="defendantInsuranceAdjusterEmail"
                                label="ADJUSTER EMAIL"
                                outlined
                                color="#2E5473"
                                :rules="[rules.email]"
                              ></v-text-field>
                              <v-text-field
                                dense
                                v-model="defendantInsuranceAdjusterPhone"
                                label="ADJUSTER PHONE"
                                outlined
                                color="#2E5473"
                                v-mask="mask"
                              ></v-text-field>
                            </v-container>
                            <v-card-actions>
                              <v-btn
                                rounded
                                color="green"
                                @click="saveDefendantInsuranceToMatter"
                                >save to matter</v-btn
                              >
                              <v-spacer></v-spacer>
                              <!-- <v-btn
                                    rounded
                                    small
                                    text
                                    class="red--text"
                                    @click="selectDefendant = false"
                                    v-if="selectDefendant"
                                    >DONE</v-btn
                                  > -->
                            </v-card-actions>
                          </v-card>
                          <!-- <v-btn @click="log">log</v-btn> -->
                        </div>
                      </div>
                    </v-expand-transition>
                    <v-btn
                      rounded
                      small
                      text
                      class="red--text"
                      @click="selectDefendant = false"
                      v-if="selectDefendant"
                      >DONE</v-btn
                    >
                  </v-container>
                </v-card>

                <!-- =+===================+==+===================+==+===================+= -->
                <!-- INTRO  -->
                <v-card
                  style="border: 2px solid black; width: auto;  overflow:auto;"
                  class="ma-1"
                  dense
                  width="90%"
                >
                  <v-container fluid>
                    <v-card-text class="title">
                      <v-row>
                        <div>INTRODUCTION PARAGAPH(S):</div>
                        <v-spacer></v-spacer>
                        <v-btn
                          rounded
                          small
                          text
                          class="red--text"
                          @click="editIntro = false"
                          v-if="editIntro"
                          >DONE</v-btn
                        >
                        <v-btn
                          class="ma-1"
                          text
                          small
                          rounded
                          outlined
                          color="orange darken-3"
                          @click="editIntro = true"
                          v-if="!editIntro"
                          >EDIT</v-btn
                        ></v-row
                      >
                    </v-card-text>
                    <v-card-title> </v-card-title>
                    <v-expand-transition>
                      <div v-if="editIntro">
                        <v-card
                          style="border: 2px solid black; width: auto;  overflow:auto;"
                          class="ma-2"
                          dense
                          width="90%"
                        >
                          <v-expand-transition>
                            <div v-if="editIntro">
                              <v-textarea
                                dense
                                v-model="introParagraph"
                                outlined
                                filled
                                color="#2E5473"
                                auto-grow
                                placeholder="CLICK AWAY TO SEE YOUR ENTRY HERE"
                                v-if="editIntro"
                              ></v-textarea>

                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  rounded
                                  small
                                  text
                                  class="red--text"
                                  @click="editSpecificIntro = false"
                                  v-if="editIntro"
                                  >DONE</v-btn
                                >
                              </v-card-actions>
                            </div>
                          </v-expand-transition>
                        </v-card>
                      </div>
                    </v-expand-transition>
                    <v-btn
                      rounded
                      small
                      text
                      class="red--text"
                      @click="editIntro = false"
                      v-if="editIntro"
                      >DONE</v-btn
                    >
                  </v-container>
                </v-card>

                <!-- FACTS  -->
                <v-card
                  style="border: 2px solid black; width: auto;  overflow:auto;"
                  class="ma-1"
                  dense
                  width="90%"
                >
                  <v-container fluid>
                    <v-card-text class="title">
                      <v-row>
                        <div>FACTS (ONE PARAGRAPH PER FACT):</div>
                        <v-spacer></v-spacer>
                        <v-btn
                          rounded
                          small
                          text
                          class="orange darken-3"
                          outlined
                          @click="editFact = true"
                          v-if="!editFact"
                          >EDIT</v-btn
                        >
                        <v-btn
                          rounded
                          small
                          text
                          outlined
                          class="red--text"
                          @click="editFact = false"
                          v-if="editFact"
                          >DONE</v-btn
                        >
                      </v-row>
                    </v-card-text>
                    <v-btn
                      v-if="editFact"
                      rounded
                      small
                      color="green"
                      class="ma-1"
                      @click="addFact"
                      outlined
                      >ADD FACT</v-btn
                    >
                    <v-expand-transition>
                      <div v-if="editFact">
                        <v-card
                          style="border: 2px solid black; width: auto;  overflow:auto;"
                          class="ma-2"
                          dense
                          width="90%"
                          v-for="(fact, i) in factParagraphs"
                          :key="i"
                        >
                          <v-card-text>
                            <div>{{ i + 1 }} {{ fact }}</div>
                          </v-card-text>
                          <v-expand-transition>
                            <v-textarea
                              dense
                              :label="`FACT ${i + 1}`"
                              v-model="factParagraphs[i]"
                              outlined
                              filled
                              class="ma-2"
                              color="#2E5473"
                              auto-grow
                              v-if="editSpecificFact"
                            ></v-textarea>
                          </v-expand-transition>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              rounded
                              small
                              text
                              class="red--text"
                              @click="editSpecificFact = true"
                              v-if="!editSpecificFact"
                              >EDIT</v-btn
                            >
                            <v-btn
                              rounded
                              small
                              text
                              class="red--text"
                              @click="editSpecificFact = false"
                              v-if="editSpecificFact"
                              >DONE</v-btn
                            >
                            <v-spacer></v-spacer>

                            <v-btn
                              small
                              rounded
                              class="red--text"
                              @click="removeFact(i)"
                              >REMOVE FACT</v-btn
                            >
                            <!-- <v-btn @click="logFact(i)">log FACT</v-btn> -->
                          </v-card-actions>
                        </v-card>
                      </div>
                    </v-expand-transition>
                    <v-btn
                      rounded
                      small
                      text
                      outlined
                      class="red--text"
                      @click="editFact = false"
                      v-if="editFact"
                      >DONE</v-btn
                    >
                  </v-container>
                  <v-btn
                    v-if="editFact"
                    outlined
                    small
                    text
                    rounded
                    class="green--text ma-1"
                    :disabled="!this.factParagraphs.length > 0"
                    @click="saveFactsToMatter"
                    >SAVE FACTS TO MATTER</v-btn
                  >
                </v-card>

                <!-- LAW  -->
                <v-card
                  style="border: 2px solid black; width: auto;  overflow:auto;"
                  class="ma-1"
                  dense
                  width="90%"
                >
                  <v-container fluid>
                    <v-card-text class="title">
                      <v-row>
                        <div>LAW AND LIABILITY</div>
                        <v-spacer></v-spacer>
                        <v-btn
                          rounded
                          small
                          text
                          class="red--text"
                          @click="editRules = false"
                          v-if="editRules"
                          >DONE</v-btn
                        >
                        <v-btn
                          class="ma-1"
                          text
                          small
                          rounded
                          outlined
                          color="orange darken-3"
                          @click="editRules = true"
                          v-if="!editRules"
                          >EDIT</v-btn
                        >
                      </v-row>
                    </v-card-text>
                    <v-expand-transition>
                      <v-card
                        style="border: 2px solid black; width: auto;  overflow:auto;"
                        class="ma-2"
                        dense
                        width="90%"
                        color="#E8E8E8"
                        v-if="editRules"
                      >
                        <v-container>
                          <v-layout row wrap>
                            <v-spacer></v-spacer>
                            <v-card-text>
                              <v-row>
                                <div class="body-1">
                                  APPLICABLE LAW SECTIONS
                                </div></v-row
                              >
                            </v-card-text>
                            <v-spacer></v-spacer>
                          </v-layout>
                        </v-container>

                        <v-container fluid>
                          <v-expand-transition>
                            <div v-if="editRules">
                              <!-- <v-card
                                      style="border: 2px solid black; width: auto;  overflow:auto;"
                                      class="ma-2"
                                      dense
                                      width="90%"
                                    > -->
                              <v-card-text class="caption">
                                <v-row
                                  ><div>
                                    CAUSES OF ACTION
                                  </div>
                                </v-row>
                              </v-card-text>

                              <v-expansion-panels popout>
                                <v-expansion-panel
                                  v-for="(cause, i) in matter.causesOfAction"
                                  :key="i"
                                  style="border: 2px solid red;"
                                >
                                  <v-expansion-panel-header>
                                    <div>{{ i + 1 }}. {{ cause }}</div>
                                  </v-expansion-panel-header>
                                  <v-expansion-panel-content>
                                    <app-code-selector
                                      :cause="cause"
                                      :matter="matter"
                                      @selected-statutes="addStatutes($event)"
                                      @selected-case-law="addCaseLaw($event)"
                                      @code-violations="
                                        addCodeViolations($event)
                                      "
                                      @reload-doc="reloadDoc"
                                    ></app-code-selector>
                                  </v-expansion-panel-content>
                                </v-expansion-panel>
                              </v-expansion-panels>
                              <!-- </v-card> -->
                            </div>
                          </v-expand-transition>
                        </v-container>
                      </v-card>
                    </v-expand-transition>
                    <v-btn
                      rounded
                      small
                      text
                      class="red--text"
                      @click="editRules = false"
                      v-if="editRules"
                      >DONE</v-btn
                    >
                  </v-container>
                </v-card>

                <!-- INJNURY LIST  -->
                <v-card
                  style="border: 2px solid black; width: auto;  overflow:auto;"
                  class="ma-1"
                  dense
                  width="90%"
                >
                  <v-container fluid>
                    <v-card-text class="title">
                      <v-row>
                        <div>INJURIES:</div>
                        <v-spacer></v-spacer>
                        <v-btn
                          rounded
                          small
                          text
                          class="red--text"
                          @click="editInjuries = false"
                          v-if="editInjuries"
                          >DONE</v-btn
                        >
                        <v-btn
                          class="ma-1"
                          text
                          small
                          rounded
                          outlined
                          color="orange darken-3"
                          @click="editInjuries = true"
                          v-if="!editInjuries"
                          >EDIT</v-btn
                        >
                      </v-row>
                    </v-card-text>
                    <v-expand-transition>
                      <v-card
                        style="border: 2px solid black; width: auto;  overflow:auto;"
                        class="ma-1"
                        dense
                        width="90%"
                        color="#E8E8E8"
                        v-if="editInjuries"
                      >
                        <div v-for="(injury, i) in injuries" :key="i">
                          <v-card flat class="ma-2" dense width="90%">
                            <v-card-text> {{ i + 1 }}. </v-card-text>
                            <v-text-field
                              dense
                              label="EDIT THIS INJURY"
                              v-model="injuries[i]"
                              outlined
                              class="ma-1"
                            >
                            </v-text-field>
                            <v-card-actions
                              ><v-spacer></v-spacer
                              ><v-btn
                                small
                                rounded
                                text
                                color="red"
                                @click="deleteInjury(i)"
                                ><v-icon>mdi-delete</v-icon></v-btn
                              ></v-card-actions
                            >
                          </v-card>
                        </div>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="green"
                            small
                            rounded
                            outlined
                            @click="addInjuryItems"
                            v-if="!addingInjuryItems"
                            >ADD INJURY</v-btn
                          >
                        </v-card-actions>
                        <v-expand-transition>
                          <div v-if="addingInjuryItems">
                            <v-card flat class="ma-1" dense width="90%">
                              <v-text-field
                                dense
                                autofocus
                                label="DESCRIBE THE INJURY"
                                v-model="tempInjury"
                                outlined
                                color="#2E5473"
                                class="ma-1"
                              ></v-text-field>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  small
                                  text
                                  rounded
                                  outlined
                                  @click="addInjury()"
                                  :disabled="!tempInjury"
                                  ><v-icon color="green"
                                    >mdi-plus</v-icon
                                  ></v-btn
                                >
                              </v-card-actions>
                            </v-card>
                            <v-btn
                              color="orange darken-3"
                              small
                              rounded
                              text
                              @click="doneAddingInjuryItems"
                              >DONE ADDING</v-btn
                            >
                          </div>
                        </v-expand-transition>
                      </v-card>
                    </v-expand-transition>

                    <v-card-actions>
                      <v-btn
                        rounded
                        small
                        text
                        class="red--text"
                        @click="editInjuries = false"
                        v-if="editInjuries"
                        >DONE</v-btn
                      >
                      <v-spacer></v-spacer>
                      <v-btn
                        v-if="editInjuries"
                        outlined
                        small
                        text
                        rounded
                        class="green--text ma-1"
                        :disabled="addingInjuryItems"
                        @click="saveInjuriesToClient"
                        >SAVE INJURIES</v-btn
                      >
                    </v-card-actions>
                  </v-container>
                </v-card>
                <!-- LOSS OF EARNINGS  -->
                <v-card
                  style="border: 2px solid black; width: auto;  overflow:auto;"
                  class="ma-1"
                  dense
                  width="90%"
                >
                  <v-container fluid>
                    <v-card-text class="title">
                      <v-row>
                        <div>LOSS OF EARNINGS:</div>
                        <v-spacer></v-spacer>
                        <v-btn
                          rounded
                          small
                          text
                          class="red--text"
                          @click="editLossOfEarnings = false"
                          v-if="editLossOfEarnings"
                          >DONE</v-btn
                        >
                        <v-btn
                          class="ma-1"
                          text
                          small
                          rounded
                          outlined
                          color="orange darken-3"
                          @click="editLossOfEarnings = true"
                          v-if="!editLossOfEarnings"
                          >EDIT</v-btn
                        >
                      </v-row>
                    </v-card-text>
                    <v-expand-transition>
                      <v-card
                        style="border: 2px solid black; width: auto;  overflow:auto;"
                        class="ma-2"
                        dense
                        width="90%"
                        color="#E8E8E8"
                        v-if="editLossOfEarnings"
                      >
                        <div v-for="(loe, i) in lossOfEarnings" :key="i">
                          <v-card flat class="ma-2" dense width="90%">
                            <v-card-text> {{ i + 1 }}. </v-card-text>
                            <v-text-field
                              dense
                              label="EDIT LOSS OF EARNING ITEM"
                              v-model="loe.description"
                              outlined
                              color="#2E5473"
                            ></v-text-field>
                            <v-text-field
                              dense
                              label="AMOUNT OF LOSS ($)"
                              v-model="loe.amount"
                              outlined
                              type="number"
                              color="#2E5473"
                              prefix="$"
                            >
                            </v-text-field>
                            <v-card-actions
                              ><v-spacer></v-spacer
                              ><v-btn
                                small
                                rounded
                                text
                                color="red"
                                @click="deleteLoe(i)"
                                ><v-icon>mdi-delete</v-icon></v-btn
                              ></v-card-actions
                            >
                          </v-card>
                        </div>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="green"
                            small
                            rounded
                            outlined
                            @click="addLoeItems"
                            v-if="!addingLoe"
                            >ADD LOSS ITEM</v-btn
                          >
                        </v-card-actions>
                        <v-expand-transition>
                          <div v-if="addingLoe">
                            <v-card flat class="ma-1" dense width="90%">
                              <v-text-field
                                dense
                                autofocus
                                label="DESCRIBE"
                                v-model="tempLossOfEarnings.description"
                                outlined
                                color="#2E5473"
                              ></v-text-field>
                              <v-text-field
                                dense
                                label="AMOUNT OF LOSS ($)"
                                v-model="tempLossOfEarnings.amount"
                                outlined
                                color="#2E5473"
                                prefix="$"
                                type="number"
                              ></v-text-field>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  :disabled="!tempLossOfEarnings.description"
                                  small
                                  text
                                  rounded
                                  outlined
                                  @click="addLoe()"
                                  ><v-icon color="green"
                                    >mdi-plus</v-icon
                                  ></v-btn
                                >
                              </v-card-actions>
                            </v-card>
                            <v-btn
                              color="orange darken-3"
                              small
                              rounded
                              text
                              @click="doneAddingLoe"
                              >DONE ADDING</v-btn
                            >
                          </div>
                        </v-expand-transition>
                      </v-card>
                    </v-expand-transition>
                    <v-card-actions>
                      <v-btn
                        rounded
                        small
                        text
                        class="red--text"
                        @click="editLossOfEarnings = false"
                        v-if="editLossOfEarnings"
                        >DONE</v-btn
                      >
                      <v-spacer></v-spacer>
                      <v-btn
                        v-if="editLossOfEarnings"
                        outlined
                        small
                        text
                        rounded
                        class="green--text ma-1"
                        :disabled="!this.lossOfEarnings.length > 0"
                        @click="saveLoeToClient"
                        >SAVE LOE(s)</v-btn
                      >
                    </v-card-actions>
                  </v-container>
                </v-card>
                <!--  QUALITY OF LIFE  -->
                <v-card
                  style="border: 2px solid black; width: auto;  overflow:auto;"
                  class="ma-1"
                  dense
                  width="90%"
                >
                  <v-container fluid>
                    <v-card-text class="title">
                      <v-row>
                        <div>QUALITY OF LIFE CHANGES:</div>
                        <v-spacer></v-spacer>
                        <v-btn
                          rounded
                          small
                          text
                          class="red--text"
                          @click="editQuality = false"
                          v-if="editQuality"
                          >DONE</v-btn
                        >
                        <v-btn
                          class="ma-1"
                          text
                          small
                          rounded
                          outlined
                          color="orange darken-3"
                          @click="editQuality = true"
                          v-if="!editQuality"
                          >EDIT</v-btn
                        >
                      </v-row>
                    </v-card-text>
                    <v-expand-transition>
                      <v-card
                        style="border: 2px solid black; width: auto;  overflow:auto;"
                        class="ma-1"
                        dense
                        width="90%"
                        color="#E8E8E8"
                        v-if="editQuality"
                      >
                        <div
                          v-for="(change, i) in qualityOfLifeChanges"
                          :key="i"
                        >
                          <v-card flat class="ma-2" dense width="90%">
                            <v-card-text> {{ i + 1 }}. </v-card-text>

                            <v-text-field
                              dense
                              label="AMOUNT OF LOSS ($)"
                              v-model="qualityOfLifeChanges[i]"
                              outlined
                              color="#2E5473"
                            >
                            </v-text-field>
                            <v-card-actions
                              ><v-spacer></v-spacer
                              ><v-btn
                                small
                                rounded
                                text
                                color="red"
                                @click="deleteQualtiy(i)"
                                ><v-icon>mdi-delete</v-icon></v-btn
                              ></v-card-actions
                            >
                          </v-card>
                        </div>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="green"
                            small
                            rounded
                            outlined
                            @click="addQualtiyItems"
                            v-if="!addingQuality"
                            >ADD QOL</v-btn
                          >
                        </v-card-actions>
                        <v-expand-transition>
                          <div v-if="addingQuality">
                            <v-card flat class="ma-1" dense width="90%">
                              <v-text-field
                                dense
                                autofocus
                                label="DESCRIBE CHANGE"
                                v-model="tempQualityOfLifeChanges"
                                outlined
                                color="#2E5473"
                              ></v-text-field>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  small
                                  text
                                  rounded
                                  outlined
                                  :disabled="!tempQualityOfLifeChanges"
                                  @click="addQuality()"
                                  ><v-icon color="green"
                                    >mdi-plus</v-icon
                                  ></v-btn
                                >
                              </v-card-actions>
                            </v-card>
                            <v-btn
                              color="orange darken-3"
                              small
                              rounded
                              text
                              @click="doneAddingQuality"
                              >DONE ADDING</v-btn
                            >
                          </div>
                        </v-expand-transition>
                      </v-card>
                    </v-expand-transition>
                    <v-card-actions>
                      <v-btn
                        rounded
                        small
                        text
                        class="red--text"
                        @click="editQuality = false"
                        v-if="editQuality"
                        >DONE</v-btn
                      >
                      <v-spacer></v-spacer>
                      <v-btn
                        v-if="editQuality"
                        outlined
                        small
                        text
                        rounded
                        class="green--text ma-1"
                        :disabled="!this.qualityOfLifeChanges.length > 0"
                        @click="saveQualityToClient"
                        >SAVE QOL(S)</v-btn
                      >
                    </v-card-actions>
                  </v-container>
                </v-card>
                <!-- SPECIAL DAMAGES  -->
                <v-card
                  style="border: 2px solid black; width: auto;  overflow:auto;"
                  dense
                  width="90%"
                  class="ma-1"
                >
                  <v-container fluid>
                    <v-card-text class="title">
                      <v-row>
                        <div>ECONOMIC DAMAGES:</div>
                        <v-spacer></v-spacer>
                        <v-btn
                          rounded
                          small
                          text
                          class="red--text"
                          @click="editDamages = false"
                          v-if="editDamages"
                          >DONE</v-btn
                        >
                        <v-btn
                          class="ma-1"
                          text
                          small
                          rounded
                          outlined
                          color="orange darken-3"
                          @click="editDamages = true"
                          v-if="!editDamages"
                          >EDIT</v-btn
                        >
                      </v-row>
                    </v-card-text>
                    <v-expand-transition>
                      <v-card
                        style="border: 2px solid black; width: auto;  overflow:auto;"
                        class="ma-2"
                        dense
                        width="90%"
                        color="#E8E8E8"
                        v-if="editDamages"
                      >
                        <div v-for="(damage, i) in specificDamages" :key="i">
                          <v-card flat class="ma-2" dense width="90%">
                            <v-card-text> {{ i + 1 }}. </v-card-text>
                            <v-text-field
                              dense
                              label="CATEGORY"
                              v-model="damage.type"
                              outlined
                              color="#2E5473"
                            >
                            </v-text-field>
                            <v-text-field
                              dense
                              label="PROVIDER NAME"
                              v-model="damage.providerName"
                              outlined
                              color="#2E5473"
                            >
                            </v-text-field>
                            <v-text-field
                              dense
                              label="DESCRIPTION OF DAMAGE"
                              v-model="damage.description"
                              outlined
                              color="#2E5473"
                            >
                            </v-text-field>
                            <v-text-field
                              dense
                              label="DOLLAR AMOUNT"
                              v-model="damage.amount"
                              outlined
                              type="number"
                              color="#2E5473"
                            >
                            </v-text-field>
                            <v-text-field
                              dense
                              label="REMAINING BALANCE"
                              v-model="damage.remainingBalance"
                              outlined
                              type="number"
                              color="#2E5473"
                            >
                            </v-text-field>
                            <v-card-actions>
                              <v-spacer></v-spacer
                              ><v-btn
                                small
                                rounded
                                text
                                color="red"
                                @click="deleteDamageItem(i)"
                                ><v-icon>mdi-delete</v-icon></v-btn
                              ></v-card-actions
                            >
                          </v-card>
                        </div>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="green"
                            small
                            rounded
                            outlined
                            @click="addDamageItems"
                            v-if="!addingDamageItems"
                            >ADD DAMAGE ITEM</v-btn
                          >
                        </v-card-actions>
                        <v-expand-transition>
                          <div v-if="addingDamageItems">
                            <v-card flat class="ma-1" dense width="90%">
                              <v-text-field
                                dense
                                autofocus
                                label="CATEGORY"
                                v-model="tempDamage.type"
                                outlined
                                color="#2E5473"
                              ></v-text-field>
                              <v-text-field
                                dense
                                autofocus
                                label="PROVIDER NAME"
                                v-model="tempDamage.providerName"
                                outlined
                                color="#2E5473"
                              ></v-text-field>
                              <v-text-field
                                dense
                                autofocus
                                label="DESCRIPTION OF DAMAGE"
                                v-model="tempDamage.description"
                                outlined
                                color="#2E5473"
                              ></v-text-field>
                              <v-text-field
                                dense
                                autofocus
                                label="DOLLAR AMOUNT"
                                v-model="tempDamage.amount"
                                outlined
                                type="number"
                                color="#2E5473"
                              ></v-text-field>
                              <v-text-field
                                dense
                                autofocus
                                label="REMAINING BALANCE"
                                v-model="tempDamage.remainingBalance"
                                outlined
                                type="number"
                                color="#2E5473"
                              ></v-text-field>
                              <v-card-actions>
                                <v-spacer></v-spacer
                                ><v-btn
                                  small
                                  rounded
                                  text
                                  color="green"
                                  @click="addDamageItem()"
                                  ><v-icon>mdi-plus</v-icon></v-btn
                                ></v-card-actions
                              >
                            </v-card>
                            <v-btn
                              color="orange darken-3"
                              small
                              rounded
                              text
                              @click="addingDamageItems = false"
                              >DONE ADDING</v-btn
                            >
                          </div>
                        </v-expand-transition>
                      </v-card>
                    </v-expand-transition>
                    <v-btn
                      rounded
                      small
                      text
                      class="red--text"
                      @click="editDamages = false"
                      v-if="editDamages"
                      >DONE</v-btn
                    >
                  </v-container>
                </v-card>

                <!-- GENERAL DAMAGES  -->
                <v-card
                  style="border: 2px solid black; width: auto;  overflow:auto;"
                  class="ma-1"
                  dense
                  width="90%"
                >
                  <v-container fluid>
                    <v-card-text class="title">
                      <v-row>
                        <div>NON-ECONOMIC DAMAGES:</div>
                        <v-spacer></v-spacer>
                        <v-btn
                          rounded
                          small
                          text
                          class="red--text"
                          @click="editGenDamages = false"
                          v-if="editGenDamages"
                          >DONE</v-btn
                        >
                        <v-btn
                          class="ma-1"
                          text
                          small
                          rounded
                          outlined
                          color="orange darken-3"
                          @click="editGenDamages = true"
                          v-if="!editGenDamages"
                          >EDIT</v-btn
                        >
                      </v-row>
                    </v-card-text>
                    <v-expand-transition>
                      <v-card
                        style="border: 2px solid black; width: auto;  overflow:auto;"
                        class="ma-2"
                        dense
                        width="90%"
                        color="#E8E8E8"
                        v-if="editGenDamages"
                      >
                        <v-container fluid>
                          <v-expand-transition>
                            <div v-if="editGenDamages">
                              <v-card flat class="ma-1" dense width="90%">
                                <v-card-text>
                                  <v-row
                                    ><div class="body-1">
                                      SELECT NON-ECONOMIC DAMAGES
                                    </div>
                                  </v-row>

                                  <v-select
                                    :items="genDamageOptions"
                                    v-model="selectedGenDamages"
                                    multiple
                                    outlined
                                    color="#2E5473"
                                    class="ma-1"
                                    dense
                                  ></v-select>
                                </v-card-text>
                                <v-expansion-panels popout>
                                  <v-expansion-panel
                                    v-for="(genDam, i) in selectedGenDamages"
                                    :key="i"
                                    style="border: 2px solid red;"
                                  >
                                    <v-expansion-panel-header>
                                      <v-card-text>
                                        <div class="caption">
                                          {{ i + 1 }}. {{ genDam }}
                                        </div>
                                      </v-card-text>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content
                                      class="ma-0 pa-0"
                                    >
                                      <app-code-selector
                                        :cause="genDam"
                                        :matter="matter"
                                        @selected-case-law="
                                          addGenDamCaseLaw($event)
                                        "
                                        @reload-doc="reloadDoc"
                                        class="ma-0 pa-0"
                                      ></app-code-selector>
                                    </v-expansion-panel-content>
                                  </v-expansion-panel>
                                </v-expansion-panels>
                              </v-card>
                            </div>
                          </v-expand-transition>
                        </v-container>
                      </v-card>
                    </v-expand-transition>
                    <v-btn
                      rounded
                      small
                      text
                      class="red--text"
                      @click="editGenDamages = false"
                      v-if="editGenDamages"
                      >DONE</v-btn
                    >
                  </v-container>
                </v-card>

                <!-- SIGNING ATTORNEY -->
                <v-card
                  style="border: 2px solid black; width: auto;  overflow:auto;"
                  class="ma-1"
                  dense
                  width="90%"
                >
                  <v-container fluid>
                    <v-card-text class="title">
                      <v-row>
                        <div>SIGNING ATTORNEY:</div>
                        <v-spacer></v-spacer>
                        <v-btn
                          rounded
                          small
                          text
                          class="red--text"
                          @click="editSigningAttorney = false"
                          v-if="editSigningAttorney"
                          >DONE</v-btn
                        >
                        <v-btn
                          class="ma-1"
                          text
                          small
                          rounded
                          outlined
                          color="orange darken-3"
                          @click="editSigningAttorney = true"
                          v-if="!editSigningAttorney"
                          >EDIT</v-btn
                        >
                      </v-row>
                    </v-card-text>
                    <v-expand-transition>
                      <div v-if="editSigningAttorney">
                        <v-container fluid>
                          <v-expand-transition>
                            <div v-if="editSigningAttorney">
                              <v-card
                                style="border: 2px solid black; width: auto;  overflow:auto;"
                                class="ma-2"
                                dense
                                width="90%"
                                color="#E8E8E8"
                              >
                                <v-card-title style="text-decoration: underline"
                                  >SELECT SIGNING ATTORNEY</v-card-title
                                >
                                <v-select
                                  :items="matter.attorneys"
                                  v-model="selectedAttorney"
                                  item-text="name"
                                  return-object
                                ></v-select>
                                <div v-if="selectedAttorney">
                                  {{ selectedAttorney.name }}
                                </div>
                              </v-card>
                              OR
                              <v-card
                                style="border: 2px solid black; width: auto;  overflow:auto;"
                                class="ma-2"
                                dense
                                width="90%"
                                color="#E8E8E8"
                              >
                                <v-card-title style="text-decoration: underline"
                                  >INPUT SIGNING ATTORNEY</v-card-title
                                >
                                <v-text-field
                                  dense
                                  label="UNPIT SIGNING ATTORNEY'S FULL NAME"
                                  v-model="inputAttorney"
                                  outlined
                                  color="#2E5473"
                                >
                                </v-text-field>

                                <div v-if="inputAttorney">
                                  By: {{ inputAttorney }}
                                </div>
                              </v-card>
                            </div>
                          </v-expand-transition>
                        </v-container>
                      </div>
                    </v-expand-transition>
                    <v-card-actions>
                      <v-btn
                        rounded
                        small
                        text
                        class="red--text"
                        @click="editSigningAttorney = false"
                        v-if="editSigningAttorney"
                        >DONE</v-btn
                      >
                    </v-card-actions>
                  </v-container>
                </v-card>
                <!-- DOCUMENT FOOTER  -->
                <v-card
                  style="border: 2px solid black; width: auto;  overflow:auto;"
                  class="ma-1"
                  dense
                  width="90%"
                >
                  <v-container fluid>
                    <v-text-field
                      dense
                      label="DOCUMENT FOOTER"
                      v-model="footerText"
                      outlined
                      color="#2E5473"
                    ></v-text-field>
                    <v-checkbox
                      label="INCLUDE PREJUDGMENT INTEREST?"
                      v-model="preJudgmentInterest"
                      value="none"
                      outlined
                      color="#2E5473"
                    ></v-checkbox>
                    <v-card-text>
                      <v-layout class="ma-auto" row v-if="preJudgmentInterest"
                        ><v-text-field
                          dense
                          autofocus
                          label="ENTER PERCENTAGE"
                          type="number"
                          style="max-width: 200px; align: right"
                          outlined
                          color="#2E5473"
                          v-model="preJudgmentInterestPercentage"
                        ></v-text-field
                        ><span style="font-size: 1.2em">%</span></v-layout
                      >
                    </v-card-text>
                  </v-container>
                </v-card>
                <!-- DOCUMENT DELIVERY -->
                <v-card
                  style="border: 2px solid black; width: auto;  overflow:auto;"
                  class="ma-2"
                  dense
                  width="90%"
                >
                  <v-container fluid>
                    <v-card-text class="title">
                      <v-row>
                        <div>
                          HOW WOULD YOU LIKE TO DELIVER THIS DEMAND?
                        </div>
                        <div>(select all that apply)</div>
                      </v-row>
                    </v-card-text>
                    <v-checkbox
                      label="PHYSICAL MAIL"
                      v-model="formOfDelivery"
                      value="mail"
                      :disabled="formOfDelivery.includes('none')"
                    ></v-checkbox>
                    <v-checkbox
                      label="E-MAIL (this will be in the form of a link)"
                      v-model="formOfDelivery"
                      value="email"
                      :disabled="formOfDelivery.includes('none')"
                    ></v-checkbox>
                    <v-text-field
                      dense
                      autofocus
                      label="INPUT RECIPIENT EMAIL"
                      outlined
                      color="#2E5473"
                      v-if="formOfDelivery.includes('email')"
                      v-model="recipientEmail"
                    ></v-text-field>
                    <v-checkbox
                      label="I'LL TAKE CARE OF THIS MYSELF"
                      v-model="formOfDelivery"
                      value="none"
                    ></v-checkbox>
                  </v-container>
                </v-card>
                <!-- EXHIBITS   -->
                <v-card
                  style="border: 2px solid black; width: auto;  overflow:auto;"
                  class="ma-2"
                  dense
                  width="90%"
                >
                  <v-container fluid>
                    <v-card-text class="title">
                      <v-row>
                        <div>EXHIBITS:</div>
                        <v-spacer></v-spacer>
                        <v-btn
                          rounded
                          small
                          text
                          class="red--text"
                          @click="editExhibits = false"
                          v-if="editExhibits"
                          >DONE</v-btn
                        >
                        <v-btn
                          class="ma-1"
                          text
                          small
                          rounded
                          outlined
                          color="orange darken-3"
                          @click="editExhibits = true"
                          v-if="!editExhibits"
                          >EDIT</v-btn
                        >
                      </v-row>
                    </v-card-text>
                    <v-expand-transition>
                      <div v-if="editExhibits">
                        <v-card
                          style="border: 2px solid black; width: auto;  overflow:auto;"
                          class="ma-2"
                          dense
                          width="90%"
                          color="#E8E8E8"
                        >
                          <v-card flat class="ma-1">
                            <v-file-input
                              class="ma-auto"
                              outlined
                              chips
                              multiple
                              label="Upload Test Documents"
                              ref="fileInput"
                              @change="onFilePicked"
                              dense
                              color="#2E5473"
                            ></v-file-input>
                            <v-text-field
                              dense
                              label="BATES PREFIX"
                              outlined
                              color="#2E5473"
                              v-model="prefix"
                            ></v-text-field>
                          </v-card>
                          <v-card
                            style="border: 2px solid black; width: auto;  overflow:auto;"
                            class="ma-2"
                            dense
                            width="90%"
                            color="#E8E8E8"
                          >
                            <v-btn
                              @click="exhibitDialog = true"
                              small
                              rounded
                              outlined
                              text
                              >edit names</v-btn
                            >
                            <ol class="ma-auto">
                              <li
                                v-for="(file, index) in exhibitList"
                                :key="index"
                              >
                                <v-layout>
                                  <div class="ma-auto">
                                    {{ file.name }}
                                  </div>
                                  <v-btn
                                    small
                                    text
                                    rounded
                                    @click="removeFile(index)"
                                  >
                                    <v-icon color="red"
                                      >mdi-minus-circle</v-icon
                                    >
                                  </v-btn>
                                </v-layout>
                              </li>
                            </ol>
                          </v-card>
                          <v-card-actions>
                            <v-btn
                              small
                              rounded
                              color="green"
                              outlined
                              text
                              @click="reloadDoc"
                              >add exhibits</v-btn
                            >
                            <v-progress-circular
                              class="text-center ma-auto"
                              indeterminate
                              size="84"
                              v-if="overlay"
                            ></v-progress-circular>
                            <v-spacer></v-spacer>
                            <v-btn
                              v-if="!overlay"
                              small
                              rounded
                              color="orange darken-3"
                              text
                              @click="viewFinalPDF"
                              >view final pdf</v-btn
                            >
                          </v-card-actions>
                        </v-card>
                      </div>
                    </v-expand-transition>
                  </v-container>
                  <v-dialog v-model="exhibitDialog" width="80%" height="80%">
                    <v-card
                      style="
                                background-color: black;
                                border-radius: 26px;
                              "
                      outlined
                      tile
                      rounded
                      class="ma-auto"
                      dense
                      width="90%"
                    >
                      <v-btn
                        tile
                        rounded
                        color="red"
                        @click="exhibitDialog = false"
                        >Exit</v-btn
                      >
                      <div v-for="(name, i) in exhibitNames" :key="i">
                        <v-card-title
                          >THIS WILL ONLY CHANGE IN THE DEMAND</v-card-title
                        >
                        <v-text-field
                          dense
                          label="DOCUMENT NAME/DESCRIPTION"
                          v-model="exhibitNames[i]"
                          outlined
                          color="#2E5473"
                        ></v-text-field>
                      </div>
                    </v-card>
                  </v-dialog>

                  <!-- <v-btn
                            v-if="editExhibits"
                            outlined
                            small
                            text
                            rounded
                            class="green--text ma-1"
                            :disabled="!this.exhibitList.length > 0"
                            @click="saveExhibitsToPlaintiff"
                            >SAVE EXHIBITS TO MATTER</v-btn
                          > -->
                </v-card>
                <!-- <v-btn rounded color="blue" @click="submit">submit</v-btn> -->
                <v-btn rounded color="blue" @click="submit">submit</v-btn>
              </v-card>
            </v-container>
          </v-form>

          <!-- </v-card> -->
        </v-flex>
        <v-progress-circular
          class="text-center ma-auto"
          indeterminate
          size="84"
          v-if="overlay"
        ></v-progress-circular>
        <v-btn
          @click="showDemandPDF = true"
          small
          rounded
          outlined
          text
          class="green--text"
          v-if="!showDemandPDF"
          >view PDF</v-btn
        >
        <v-flex xs12 sm12 md7 lg8>
          <v-expand-x-transition>
            <!-- <v-card
              flat
              outlined
              class="ma-1"
              max-height="60%"
              style="
                overflow-x: scroll;
                border-radius: 26px;
                border: 1px solid #18cae6;
                position: sticky;
                top:50px;
              "
              v-if="showDemandPDF"
            > -->
            <v-card
              class="ma-1 pa-0"
              dense
              style="border: 2px solid black; width: auto;  overflow:auto;  position: sticky;
                top:50px;"
              color="#d8e2eb"
            >
              <v-card-actions>
                <v-btn
                  @click="reloadDoc"
                  small
                  rounded
                  text
                  color="orange darken-3"
                  v-if="showDemandPDF"
                  >RELOAD PREVIEW</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn
                  @click="showDemandPDF = false"
                  small
                  rounded
                  text
                  class="red--text"
                  v-if="showDemandPDF"
                  >hide</v-btn
                >
              </v-card-actions>
              <v-container fluid>
                <v-responsive
                  :aspect-ratio="1 / 1.2941"
                  style="
                    overflow-x: scroll;
                    border-radius: 26px;
                  "
                  v-if="showDemandPDF"
                >
                  <iframe
                    v-if="!overlay"
                    style="border: 0"
                    :src="iframeSrc"
                    width="100%"
                    height="100%"
                  ></iframe
                ></v-responsive>
              </v-container>
            </v-card>
          </v-expand-x-transition>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- <h2>PLAINTIFF (CLIENT IN DATABASE)</h2>
    <p>{{ plaintiff }}</p>
    <h3>FIRM:</h3>
    <div v-if="firm">
      <p>{{ firm.firmName }}</p>
      <p>{{ firm.firmAddressLine }}, {{ firm.firmCityStateZip }}</p>
    </div>
    <div v-else>
      <p>NO FIRM</p>
    </div> -->
  </div>
</template>

<script>
/* eslint-disable */
// eslint-disable-next-line
import * as firebase from "firebase";
import * as moment from "moment";
import { mask } from "vue-the-mask";

import { PDFDocument, StandardFonts, rgb, PageSizes, drawPage } from "pdf-lib";
// import { PDFDocument, StandardFonts, rgb, PageSizes } from "pdf-lib";
// import { PageSizes, PDFDocument } from "pdf-lib";
// import * as pdfjsLib from "pdfjs-dist";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
export default {
  directives: {
    mask,
  },
  data: () => ({
    // firm: null,
    //controls
    overlay: false,
    showDemandPDF: false,
    editBasicInfo: false,
    selectDefendant: false,
    editIntro: false,
    editSpecificIntro: false,
    editFact: false,
    editSpecificFact: false,
    editDemandType: false,
    editRules: false,
    showingCause: false,
    editDamages: false,
    editInjuries: false,
    allowAddIntro: false,
    allowAddFact: false,
    liabilityDialog: false,
    addingInjuryItems: false,
    addingDamageItems: false,
    addingLoe: false,
    editLossOfEarnings: true,
    editQuality: true,
    addingQuality: false,
    editGenDamages: true,
    editExhibits: true,
    selectedFirm: null, 
    exhibitList: [],
    exhibitNames: [],
    demandAmount: 0,
    editSigningAttorney: true,
    selectedAttorney: null,
    inputAttorney: null,
    mask: "(###) ###-####",
    formOfDelivery: [],
    demandType: null,
    demandTypeOptions: ["POLICY-LIMIT DEMAND", "STANDARD DEMAND", "UIM POLICY LIMIT DEMAND"],
    demandLabel: "***INPUT TYPE OF DEMAND***",
    preJudgmentInterest: false,
    doc: null,
    docTitle:
      "FOR CONFIDENTIAL SETTLEMENT DISCUSSION ONLY - EVIDENCE CODE SECTION 1152",
    docDate: moment().format("LL"),
    timeLimit: 21,
    recipientEmail: null,
    preJudgmentInterestPercentage: 10,
    iframeSrc: null,
    tempPlaintiff: null,
    plaintiff: null,
    matter: null,
    formList: null,
    formResponseList: [],
    specificDamages: [],
    demandDate: moment().format("MMMM Do YYYY"),
    selectedProvider: null,
    
    // introParagraphs: [],
    introParagraph:
      "This letter constitutes our client's formal settlement demand for the above referenced incident. The basis for this demand is as follows: ",

    tempFactParagraph: null,
    tempLiabilityParagraph: null,
    tempLossOfEarnings: {
      description: null,
      amount: null,
    },
    tempQualityOfLifeChanges: null,
    tempDamage: {
      type: null,
      providerName: null,
      description: null,
      amount: null,
      remainingBalance: null,
    },
    tempPainAndSufferingParagraph: null,

    qualityOfLifeChanges: [],
    liabilityParagraphs: [],
    factParagraphs: [],
    painAndSufferingParaphraphs: [],

    painAndSufferingParaphraphOptions: [],
    liabilityParagraphOptions: [],

    tempInjury: null,
    injuries: [],
    lossOfEarnings: [],
    // tempLoe: {
    //   description: null,
    //   amount: 0,
    // },
    footerText: "",
    defendant: null,
    defendantList: [],

    rules: {
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
    },
    ruleType: null,
    ruleSearchInput: null,
    statutes: null,
    caseLaw: null,
    codeViolations: null,

    genDamageOptions: [
      "Physical Pain, Mental Suffering, and Emotional Distress",
      "Loss of Consortium",
      "Wrongful Death (Noneconomic)",
    ],
    selectedGenDamages: [],
    genDamCaseLaw: null,
    testDocBuffer: null,
    finalPDF: null,
    pdfBytes: null,

    exhibitDialog: false,
    allowExhibitDialog: false,
    exhibitPageLinks: [],
    offset: 0,

    defendantInsuranceName: null,
    defendantInsuranceStreetAddress: null,
    defendantInsuranceCityStateZip: null,
    defendantInsurancePolicyNumber: null,
    defendantInsuranceClaimNumber: null,
    defendantInsuranceAdjusterName: null,
    defendantInsuranceAdjusterEmail: null,
    defendantInsuranceAdjusterPhone: null,


    plaintiffInsuranceName: null,
    plaintiffInsuranceStreetAddress: null,
    plaintiffInsuranceCityStateZip: null,
    plaintiffInsurancePolicyNumber: null,
    plaintiffInsuranceClaimNumber: null,
    plaintiffInsuranceAdjusterName: null,
    plaintiffInsuranceAdjusterEmail: null,
    plaintiffInsuranceAdjusterPhone: null,
    //prior demand test
    priorDemands: [],
    selectedPriorDemand: null,
    finalBytes: null,
    prefix: `DEMAND`, 
    uimDocListDialog: false
  }),
  computed: {
    // damages() {
    //   //create a new damages object??
    // },
    // facts() {
    //   let finalFactsParagraph = [];
    //   this.factParagraphs.forEach((fact) => {
    //     finalFactsParagraph.push(`${fact.text}\n\n`);
    //   });
    //   return finalFactsParagraph;
    // },

    docDueDate() {
      return moment().add(this.timeLimit, "days").format("LL");
    },
    user() {
      return this.$store.getters.user;
    },
    firm() {
      return this.$store.getters.firm;
    },
    totalRemainingBalance() {
      let total = 0.0;
      this.specificDamages.forEach((damage) => {
        if (!isNaN(damage.remainingBalance)) {
          if (
            damage.remainingBalance !== null &&
            damage.remainingBalance !== undefined
          ) {
            let amount = parseFloat(damage.remainingBalance);
            total += amount;
          } else {
            total += 0.0;
          }
        } else {
          total += 0.0;
        }
      });
      return total;
    },
  },
  watch: {
    // priorDemands(val){
    //   if(val !== undefined && val !== null){
    //     //get the prior demand data from database
    //     //set all the properties to the corresponding data 
    //     //get prior demand documents from storage?  
    //     console.log("priorDemands", val);
    //   }
    // },
    selectedPriorDemand(val){
      console.log("selectedPriorDemand", val)
      window.open(val.url, "_blank");
    },
    inputAttorney(val){
      if (val !== undefined && val !== null) {
        this.selectedAttorney = null;
      }
    },
    formOfDelivery(val) {
      if (val.includes("none")) {
        let i = val.indexOf("email");
        if (i !== -1) {
          val.splice(i, 1);
        }
        let ii = val.indexOf("mail");
        if (ii !== -1) {
          val.splice(ii, 1);
        }
      }
      if (
        this.defendantInsuranceAdjusterEmail !== null &&
        this.defendantInsuranceAdjusterEmail !== undefined &&
        !this.selectedProvider
      ) {
        this.recipientEmail = this.defendantInsuranceAdjusterEmail;
      } else if (this.selectedProvider && this.selectedProvider.adjusterEmail) {
        this.recipientEmail = this.selectedProvider.adjusterEmail;
      }
    },
    plaintiff(val) {
      console.log("plaintiff:", val);
      if (val !== undefined && val !== null) {
        window.document.title = `DEMAND - ${val.fullName.toUpperCase()}`;
        if (this.demandType !== undefined && this.demandType !== null) {
          this.footerText = `${
            this.demandType
          } - ${val.fullName.toUpperCase()}`;
        } else {
          this.footerText = `DEMAND - ${val.fullName.toUpperCase()}`;
        }
        if (val.injuries !== null && val.injuries !== undefined) {
          this.injuries = val.injuries;
        } else {
          console.log("no injuries in client document");
        }
        if (val.lossOfEarnings !== null && val.lossOfEarnings !== undefined) {
          this.lossOfEarnings = val.lossOfEarnings;
        } else {
          console.log("no loss of earnings in client document");
        }
        if (
          val.qualityOfLifeChanges !== null &&
          val.qualityOfLifeChanges !== undefined
        ) {
          this.qualityOfLifeChanges = val.qualityOfLifeChanges;
        } else {
          console.log("no quality of life changes in client document");
        }
      }
    },
    formList(val) {
      val.forEach((form) => {
        if (val.length > 0) {
          firebase
            .firestore()
            .collection("matters")
            .doc(this.$route.params.id)
            .collection("clients")
            .doc(this.$route.params.client)
            .collection("formList")
            .doc(form.id)
            .onSnapshot((doc) => {
              let data = doc.data();
              this.formResponseList.push(data);
              // console.log("data added to formResponseList: ", data);
              // console.log("Full formResponseList: ", this.formResponseList);
            });
        } else {
          console.log("formList watch function has no list");
        }
      });
    },
    matter(val) {
      // console.log("watching matter", val);
      if (val.damages) {
        console.log("watching damages: ", val.damages);
        val.damages.forEach((damage) => {
          if (damage.party === this.plaintiff.clientSlug) {
            this.specificDamages.push(damage);
          }
        });
      }
      // if(this.matter.defendant)
      if (val.defendants) {
        val.defendants.forEach((defendant) => {
          this.defendantList.push(defendant);
        });
      }
      if (val.factParagraphs && val.factParagraphs.length > 0) {
        this.factParagraphs = val.factParagraphs;
      }

      
    },
    formResponseList(val) {
      if (val.length > 0) {
        val.forEach((response) => {
          if (response.name === "FORM INTERROGATORIES - GENERAL (CALIFORNIA)") {
            if (response.responses) {
              let damageObj;
              response.responses[23].setResponses.forEach((set) => {
                let c = parseFloat(set.personalInjuryCost);
                damageObj = {
                  providerName: set.personalInjuryProviderList,
                  amount: c,
                  remainingBalance: c,
                  type: "Medical Expense",
                  description: "",
                  datesOfService: null,
                };
                this.specificDamages.push(damageObj);
              });
              response.responses[24].setResponses.forEach((set) => {
                let c = parseFloat(set.personalInjuryMedicationCost);
                damageObj = {
                  providerName: set.personalInjuryMedicationList,
                  amount: c,
                  remainingBalance: c,
                  description: "",
                  type: "Form Response",
                  datesOfService: null,
                };
                this.specificDamages.push(damageObj);
                //pull the rest of the damage information from responses to form interrogatorties
                //(6 series)
              });
            }
          }
        });
      }
    },
    user(val) {
      if (val !== undefined && val !== null) {
        this.$store.dispatch("getFirm", val.firmSlug);
      }
    },
    form(val) {
      console.log(val);
    },
    // specificDamages(val) {
    //   this.injuries = [];
    //   if (val.length > 0) {
    //     val.forEach((damage) => {
    //       this.injuries.push(`${damage.description.toUpperCase()}`);
    //     });
    //   }
    // },
    demandType(val){
      // console.log("demandType watcher",val)
      if (val === 'POLICY LIMIT DEMAND' || val === 'STANDARD DEMAND'){
        // if(this.selectedProvider){
          return this.introParagraph = `This letter constitutes our client's formal settlement demand for the above referenced incident. The basis for this demand is as follows: `
        // }
      }
    },
    selectedProvider(val){
      if(val !== null && val !== undefined){
        if(this.demandType === 'UIM POLICY LIMIT DEMAND')
          return this.introParagraph = `    We write to demand settlement of damages sustained by our client/your insured, ${this.plaintiff.fullName}, in an incident that occurred on or about ${this.matter.dateOfLoss}. The attached documents support our position that the value of the claim is significant and, in any event, well beyond the maximum recovery available under ${this.plaintiff.fullName.toUpperCase()}'S UM/UIM insurance policy with ${this.selectedProvider.name || '****'} after recovery of the third-party policy limits. As such, we hereby submit the following UIM POLICY LIMIT DEMAND on behalf of ${this.plaintiff.fullName} and also demand that ${this.selectedProvider.name || '****'} pay any applicable remaining medical payments (“medpay”) and waive its right to recovery of any medpay paid to date.`
        }
    }
  },
  methods: {
    viewFinalPDF() {
      window.open(this.finalPDF, "_blank");
    },
    onFilePicked() {
      this.exhibitPageLinks = [];
      if (event.target.files) {
        const fileList = Array.from(event.target.files);
        fileList.forEach((file) => {
          this.exhibitList.push(file);
          this.exhibitNames.push(file.name);
        });
        // console.log("exhibitList:", this.exhibitList);
        // console.log("exhibitNames:", this.exhibitNames);

        //for hyperlinking exhibits to demand - might be causing problems

        // (async () => {
        //   let exhibitNum = 0;
        //   let linkPage = 0;
        //   let numberOfPages = 0;
        //   let prevExNumPages = 0;

        //   if (this.doc) {
        //     await this.doc.getBuffer((buffer) => {
        //       (async () => {
        //         let tempDemand = await PDFDocument.load(buffer);
        //         let demandPages = await tempDemand.getPages();
        //         // await console.log("demandPages", demandPages);
        //         // this.offset = demandPages.length;
        //         // for (let demandPage of demandPages) {
        //         //   await this.offset++
        //         // }
        //         // this.offset = await demandPages.length;
        //         this.offset = await demandPages.length;
        //         for (let ex of this.exhibitList) {
        //           await exhibitNum++;
        //           let buf = await ex.arrayBuffer();
        //           let tempEx = await PDFDocument.load(buf);
        //           let pages = await tempEx.getPages();
        //           numberOfPages = await pages.length;
        //           // for (let page of pages ){
        //           //   await numberofpages++
        //           // }
        //           // let linkPageNumber;
        //           if (exhibitNum < 2) {
        //             linkPage = (await this.offset) + 1;
        //           } else {
        //             linkPage = (await linkPage) + prevExNumPages + 1;
        //           }

        //           await this.exhibitPageLinks.push({
        //             exhibitNum,
        //             pages: numberOfPages,
        //             linkPage: linkPage,
        //           });
        //           // await console.log(
        //           //   "exhibitPageLinks from onFilePicked",
        //           //   this.exhibitPageLinks
        //           // );
        //           prevExNumPages = numberOfPages;
        //         }
        //         // await console.log("exhibitPageLinks: ", this.exhibitPageLinks);
        //         // await console.log("offset: ", this.offset);
        //       })();
        //     });
        //   }
        // })();
      }
    },
    removeFile(index) {
      this.exhibitList.splice(index, 1);
    },
    saveExhibitsToPlaintiff() {
      console.log("saving exhibits to storage");

      console.log("getting exhibit download URL");

      console.log("saving url to gatabase");
    },
    addInjury() {
      this.injuries.push(this.tempInjury);
      this.tempInjury = null;
    },
    addLoe() {
      this.lossOfEarnings.push(this.tempLossOfEarnings);
      this.tempLossOfEarnings = {
        description: null,
        amount: 0,
      };
    },
    addQuality() {
      this.qualityOfLifeChanges.push(this.tempQualityOfLifeChanges);
      this.tempQualityOfLifeChanges = null;
    },
    doneAddingInjuryItems() {
      this.addingInjuryItems = false;
    },
    doneAddingLoe() {
      this.addingLoe = false;
    },
    doneAddingQuality() {
      this.addingQuality = false;
    },
    addInjuryItems() {
      this.addingInjuryItems = true;
    },
    addLoeItems() {
      this.addingLoe = true;
    },
    addQualtiyItems() {
      this.addingQuality = true;
    },
    deleteInjury(i) {
      this.injuries.splice(i, 1);
    },
    deleteLoe(i) {
      this.lossOfEarnings.splice(i, 1);
    },
    deleteQualtiy(i) {
      this.qualityOfLifeChanges.splice(i, 1);
    },
    addStatutes(e) {
      // console.log("statutes", e);
      this.statutes = e;
    },
    addCaseLaw(e) {
      // console.log("caseLaw", e);
      this.caseLaw = e;
    },
    addGenDamCaseLaw(e) {
      // console.log(e);
      this.genDamCaseLaw = e;
    },
    addCodeViolations(e) {
      // console.log("codeViiolations", e);
      this.codeViolations = e;
    },
    logTempFact() {
      console.log(this.tempFactParagraph);
    },
    logFact(i) {
      console.log(this.factParagraphs[i]);
    },
    removeIntroParagraph(i) {
      this.introParagraphs.splice(i, 1);
    },
    saveInjuriesToClient() {
      console.log("saving injuries", this.injuries);
      let array = [];
      if (this.injuries.length > 0) {
        this.injuries.forEach((injury) => {
          array.push(injury);
        });
        firebase
          .firestore()
          .collection("matters")
          .doc(this.matter.matterSlug)
          .collection("clients")
          .doc(this.plaintiff.partySlug)
          .update({
            injuries: array,
          })
          .then(() => {
            console.log("saved injuries to client");
          })
          .catch((e) => {
            console.error(e);
          });
      }
    },
    saveLoeToClient() {
      console.log("saving Loss of Earninga", this.lossOfEarnings);
      let array = [];
      if (this.lossOfEarnings.length > 0) {
        this.lossOfEarnings.forEach((loe) => {
          array.push(loe);
        });
        firebase
          .firestore()
          .collection("matters")
          .doc(this.matter.matterSlug)
          .collection("clients")
          .doc(this.plaintiff.partySlug)
          .update({
            lossOfEarnings: array,
          })
          .then(() => {
            console.log("saved loss of earnings to client");
          })
          .catch((e) => {
            console.error(e);
          });
      }
    },
    saveQualityToClient() {
      console.log("saving Quality of Life Changes", this.qualityOfLifeChanges);
      let array = [];
      if (this.qualityOfLifeChanges.length > 0) {
        this.qualityOfLifeChanges.forEach((quality) => {
          array.push(quality);
        });
        firebase
          .firestore()
          .collection("matters")
          .doc(this.matter.matterSlug)
          .collection("clients")
          .doc(this.plaintiff.partySlug)
          .update({
            qualityOfLifeChanges: array,
          })
          .then(() => {
            console.log("saved quality of life changes to client");
          })
          .catch((e) => {
            console.error(e);
          });
      }
    },
    saveFactsToMatter() {
      console.log("saving factParagraphs", this.factParagraphs);
      let array = [];
      if (this.factParagraphs.length > 0) {
        this.factParagraphs.forEach((parag) => {
          // array.push(parag.text);
          array.push(parag);
        });
        console.log(array);

        firebase
          .firestore()
          .collection("matters")
          .doc(this.matter.matterSlug)
          .update({
            factParagraphs: array,
          })
          .then(() => {
            console.log("saved factParagraphs to matter");
          })
          .catch((e) => {
            console.error(e);
          });
      }
    },
    removeFact(i) {
      this.factParagraphs.splice(i, 1);
    },
    addFact() {
      this.factParagraphs.push(`EDIT THIS TEXT`);
      // this.factParagraphs.push(`${this.tempFactParagraph}`);
      this.tempFactParagraph = "";
      console.log("factParagraphs: ", this.factParagraphs);
    },
    saveDefendantInsuranceToMatter() {
      console.log("defendant", this.defendant);
      console.log("defendantList", this.defendantList);

      if (this.defendant !== null && this.defendant !== undefined) {
        if (!this.defendant.insurance) {
          let newDefendant = {
            ...this.defendant,
            insurance: [],
          };
          newDefendant.insurance = [
            {
              name: this.defendantInsuranceName,
              streetAddress: this.defendantInsuranceStreetAddress,
              cityStateZip: this.defendantInsuranceCityStateZip,
              policyNumber: this.defendantInsurancePolicyNumber,
              claimNumber: this.defendantInsuranceClaimNumber,
              adjusterName: this.defendantInsuranceAdjusterName,
              adjusterEmail: this.defendantInsuranceAdjusterEmail,
              adjusterPhone: this.defendantInsuranceAdjusterPhone,
            },
          ];
          console.log("newDefendant-1", newDefendant)
          let i = this.matter.defendants.indexOf(this.defendant);
          console.log("index of defendant in defendants", i);
          console.log("defendant", this.defendant);
          // this.defendant.insuranceProviders.push({})
          this.defendantList.splice(i, 1, newDefendant);
          // console.log("matter:", this.matter);
          console.log("defendantList", this.defendantList);
          firebase
            .firestore()
            .collection("matters")
            .doc(this.matter.matterSlug)
            .update({
              defendants: this.defendantList,
            })
            .then(() => {
              console.log("successfully added insurance provider to defendant");
            })
            .catch((e) => {
              console.error(e);
            });
        } else if (this.defendant.insurance) {
          let newDefendant = {
            ...this.defendant,
          };
          if (newDefendant.insurance.length > 0) {
            newDefendant.insurance.push({
              name: this.defendantInsuranceName,
              streetAddress: this.defendantInsuranceStreetAddress,
              cityStateZip: this.defendantInsuranceCityStateZip,
              policyNumber: this.defendantInsurancePolicyNumber,
              claimNumber: this.defendantInsuranceClaimNumber,
              adjusterName: this.defendantInsuranceAdjusterName,
              adjusterEmail: this.defendantInsuranceAdjusterEmail,
              adjusterPhone: this.defendantInsuranceAdjusterPhone,
            });
             console.log("newDefendant-2", newDefendant)
             let i = this.matter.defendants.indexOf(this.defendant);
          console.log("index of defendant in defendants", i);
          console.log("defendant", this.defendant);
          // this.defendant.insuranceProviders.push({})
          this.defendantList.splice(i, 1, newDefendant);
          // console.log("matter:", this.matter);
          console.log("defendantList", this.defendantList);
          firebase
            .firestore()
            .collection("matters")
            .doc(this.matter.matterSlug)
            .update({
              defendants: this.defendantList,
            })
            .then(() => {
              console.log("successfully added insurance provider to defendant");
            })
            .catch((e) => {
              console.error(e);
            });
          } else {
            newDefendant.insurance = [
              {
                name: this.defendantInsuranceName,
                streetAddress: this.defendantInsuranceStreetAddress,
                cityStateZip: this.defendantInsuranceCityStateZip,
                policyNumber: this.defendantInsurancePolicyNumber,
                claimNumber: this.defendantInsuranceClaimNumber,
                adjusterName: this.defendantInsuranceAdjusterName,
                adjusterEmail: this.defendantInsuranceAdjusterEmail,
                adjusterPhone: this.defendantInsuranceAdjusterPhone,
              },
            ];
             console.log("newDefendant-3", newDefendant)
             let i = this.matter.defendants.indexOf(this.defendant);
          console.log("index of defendant in defendants", i);
          console.log("defendant", this.defendant);
          // this.defendant.insuranceProviders.push({})
          this.defendantList.splice(i, 1, newDefendant);
          // console.log("matter:", this.matter);
          console.log("defendantList", this.defendantList);
          firebase
            .firestore()
            .collection("matters")
            .doc(this.matter.matterSlug)
            .update({
              defendants: this.defendantList,
            })
            .then(() => {
              console.log("successfully added insurance provider to defendant");
            })
            .catch((e) => {
              console.error(e);
            });
          }


          // let i = this.matter.defendants.indexOf(this.defendant);
          // console.log("index of defendant in defendants", i);
          // console.log("defendant", this.defendant);
          // // this.defendant.insuranceProviders.push({})
          // this.defendantList.splice(i, 1, newDefendant);
          // // console.log("matter:", this.matter);
          // console.log("defendantList", this.defendantList);
          // firebase
          //   .firestore()
          //   .collection("matters")
          //   .doc(this.matter.matterSlug)
          //   .update({
          //     defendants: this.defendantList,
          //   })
          //   .then(() => {
          //     console.log("successfully added insurance provider to defendant");
          //   })
          //   .catch((e) => {
          //     console.error(e);
          //   });
        }
      }
    },
    savePlaintiffInsuranceToMatter() {
      console.log("plaintiff", this.plaintiff);
      // console.log("defendantList", this.defendantList);

      if (this.plaintiff !== null && this.plaintiff !== undefined) {
        // if (!this.plaintiff.insurance) {
          // let newPlaintiff = {
          //   ...this.plaintiff,
          //   insurance: [],
          // };
          // newPlaintiff.insurance = [
          //   {
          //     name: this.plaintiffInsuranceName,
          //     streetAddress: this.plaintiffInsuranceStreetAddress,
          //     cityStateZip: this.plaintiffInsuranceCityStateZip,
          //     policyNumber: this.plaintiffInsurancePolicyNumber,
          //     claimNumber: this.plaintiffInsuranceClaimNumber,
          //     adjusterName: this.plaintiffInsuranceAdjusterName,
          //     adjusterEmail: this.plaintiffInsuranceAdjusterEmail,
          //     adjusterPhone: this.plaintiffInsuranceAdjusterPhone,
          //   },
          // ];
        // } else if (this.plaintiff.insurance) {
          // let newPlaintiff = {
          //   ...this.plaintiff,
          // };
          // if (newPlaintiff.insurance.length > 0) {
          //   newPlaintiff.insurance.push({
          //     name: this.plaintiffInsuranceName,
          //     streetAddress: this.plaintiffInsuranceStreetAddress,
          //     cityStateZip: this.plaintiffInsuranceCityStateZip,
          //     policyNumber: this.plaintiffInsurancePolicyNumber,
          //     claimNumber: this.plaintiffInsuranceClaimNumber,
          //     adjusterName: this.plaintiffInsuranceAdjusterName,
          //     adjusterEmail: this.plaintiffInsuranceAdjusterEmail,
          //     adjusterPhone: this.plaintiffInsuranceAdjusterPhone,
          //   });
          // } else {
          //   newPlaintiff.insurance = [
          //     {
          //       name: this.plaintiffInsuranceName,
          //       streetAddress: this.plaintiffInsuranceStreetAddress,
          //       cityStateZip: this.plaintiffInsuranceCityStateZip,
          //       policyNumber: this.plaintiffInsurancePolicyNumber,
          //       claimNumber: this.plaintiffInsuranceClaimNumber,
          //       adjusterName: this.plaintiffInsuranceAdjusterName,
          //       adjusterEmail: this.plaintiffInsuranceAdjusterEmail,
          //       adjusterPhone: this.plaintiffInsuranceAdjusterPhone,
          //     },
          //   ];


          // }

          // let i = this.matter.plaintiffs.indexOf(this.defendant);
          // console.log("index of defendant in defendants", i);
          // console.log("defendant", this.defendant);
          // // this.defendant.insuranceProviders.push({})
          // this.defendantList.splice(i, 1, newDefendant);
          // // console.log("matter:", this.matter);
          // console.log("defendantList", this.defendantList);
          // firebase
          //   .firestore()
          //   .collection("matters")
          //   .doc(this.matter.matterSlug)
          //   .update({
          //     defendants: this.defendantList,
          //   })
          //   .then(() => {
          //     console.log("successfully added insurance provider to defendant");
          //   })
          //   .catch((e) => {
          //     console.error(e);
          //   });

      // }
      let insurance = {
          name: this.plaintiffInsuranceName,
          streetAddress: this.plaintiffInsuranceStreetAddress,
          cityStateZip: this.plaintiffInsuranceCityStateZip,
          policyNumber: this.plaintiffInsurancePolicyNumber,
          claimNumber: this.plaintiffInsuranceClaimNumber,
          adjusterName: this.plaintiffInsuranceAdjusterName,
          adjusterEmail: this.plaintiffInsuranceAdjusterEmail,
          adjusterPhone: this.plaintiffInsuranceAdjusterPhone,
        }
      firebase
        .firestore()
        .collection("matters")
        .doc(this.matter.matterSlug)
        .collection("clients")
        .doc(this.plaintiff.clientSlug)
        .update({
          insurance: firebase.firestore.FieldValue.arrayUnion(insurance)
        }).then(()=>{console.log("saved insurance to plaintiff")}).catch(e=>{console.error(e)});

      }
    },
    addDamageItems(){
      this.addingDamageItems = true;
    },
    addDamageItem() {
      if (this.tempDamage.remainingBalance !== null && this.tempDamage.remainingBalance !== undefined) {
        let newDamageItem = {
          ...this.tempDamage,
        };
        this.specificDamages.push(newDamageItem);
        this.tempDamage = {};
      }
    },
    deleteDamageItem(i) {
      this.specificDamages.splice(i, 1);
    },
    logDamages() {
      console.log("specificDamages", this.specificDamages);
    },
    submit() {
      this.overlay = true;
      // console.log(this.plaintiff.fullName);
      // console.log(this.formOfDelivery);
      // console.log(this.demandType);
      // console.log(this.doc)
      // let fileName = `${plaintiff.clientSlug}demand-${demandDate}.pdf`
      let demandNumber = 0;
      if(this.plaintiff.demands && this.plaintiff.demands.length > 0){
        demandNumber = this.plaintiff.demands.length + 1;
      } else {
        demandNumber = 1;
      }
      
      if(this.finalPDF) {
        let ref = firebase.storage().ref();
        let demandRef = ref.child(`${this.plaintiff.clientSlug}/demand-${this.demandDate}-${demandNumber}.pdf`)

        
        // demandRef.put(this.finalPDF).then(() => {
        demandRef.put(this.finalBytes).then(() => {
          console.log('uploaded demand')
          demandRef.getDownloadURL()
            .then((url) => {
             
              let tempDemandDate = this.demandDate;
              
              console.log(url)
              let demand = {
                name: `${this.plaintiff.clientSlug}/demand-${tempDemandDate}-${demandNumber}.pdf`,
                url: url,
                // exhibitNames: this.exhibitNames,
                // demandAmount: this.demandAmount,
                // selectedAttorney: this.selectedAttorney,
                // inputAttorney: this.inputAttorney,
                // formOfDelivery: this.formOfDelivery,
                // demandType: this.demandType,
                // demandLabel: this.demandLabel,
                // preJudgmentInterest: this.preJudgmentInterest,
                // docTitle: this.docTitle, 
                // docDate: tempDocDate,
                // timeLimit: this.timeLimit,
                // recipientEmail: this.recipientEmail,
                // preJudgmentInterestPercentage: this.preJudgmentInterestPercentage,
                // specificDamages: this.specificDamages,
                // demandDate: tempDemandDate,
                // selectedProvider: this.selectedProvider,
                // introParagraph : this.introParagraph,  
                // qualityOfLifeChanges: this.qualityOfLifeChanges,
                // // liabilityParagraphs: this.liabilityParagraphs,
                // liabilityParagraphs: liab,
                // // factParagraphs: this.factParagraphs,
                // // painAndSufferingParaphraphs: pain,
                // // injuries: this.injuries,
                // // lossOfEarnings: this.lossOfEarnings,
                // footerText: this.footerText,
                // defendant: this.defendant,
                // statutes: stats,
                // caseLaw: this.caseLaw,
                // codeViolations: codViol,
                // selectedGenDamages: this.selectedGenDamages,
                // genDamCaseLaw: this.genDamCaseLaw,
              };

              console.log(demand);
              // firebase.firestore()
              // .collection("matters")
              // .doc(this.$route.params.id)
              // .collection("clients")
              // .doc(this.$route.params.client)
              // .collection("demands")
              // .doc().set({
              //   demand
              // }).then(()=>{               
                firebase.firestore()
                .collection("matters")
                .doc(this.$route.params.id)
                .collection("clients")
                .doc(this.$route.params.client)
                .update({
                  demands: firebase.firestore.FieldValue.arrayUnion(demand)
                }).then(()=> {
                  this.overlay = false;
                }).catch((error)=> {
                  console.error(error)
                })            
              // }).catch((error)=> {
              //   console.error(error)
              // })
              // this.overlay = false;
            })
            .catch((error)=> {
              console.error(error)
            })
        })
      } else {
        let tempDemandDate = this.demandDate;
        let ref = firebase.storage().ref();
        let demandRef = ref.child(`${this.plaintiff.clientSlug}/demand-${tempDemandDate}-${demandNumber}.pdf`)
        this.doc.getBlob((blob)=> {
          demandRef.put(blob).then(() => {
          console.log('uploaded demand')
          demandRef.getDownloadURL()
            .then((url) => {
              let demand = {
                name: `${this.plaintiff.clientSlug}/demand-${tempDemandDate}-${demandNumber}.pdf`,
                url: url,
              }

              console.log(url)
              // firebase.firestore()
              // .collection("matters")
              // .doc(this.$route.params.id)
              // .collection("clients")
              // .doc(this.$route.params.client)
              // .collection("demands")
              // .doc().set({
              //   demand
              // }).then(()=>{
                firebase.firestore()
                .collection("matters")
                .doc(this.$route.params.id)
                .collection("clients")
                .doc(this.$route.params.client)
                .update({
                  demands: firebase.firestore.FieldValue.arrayUnion(demand)
                }).then(()=> {
                  this.overlay = false;
                }) .catch((error)=> {
                  console.error(error)
                })             
              // }).catch((error)=> {
              //   console.error(error)
              // })
            })
            .catch((error)=> {
              console.error(error)
            })
        })
        })
        
      }
      
      

    },
    log() {
      console.log(this.plaintiff.fullName);
      console.log("this.defendant", this.defendant);
      console.log("this.matter", this.matter);
    },
    logForm() {
      console.log("refs", this.$refs);
    },
    reloadDoc() {
        // console.log("data",this.$data);
        // let data = {...this.$data}
        // // console.log("data", data);
        // demandData = {

        // }
        // firebase
        //   .firestore()
        //   .collection("matters")
        //   .doc(this.$route.params.id)
        //   .collection("clients")
        //   .doc(this.$route.params.client)
        //   .update({
        //     demand: data
        //   })
        
        this.overlay = true
        console.log("overlay")
        // let letterhead;
        // if(this.user.letterhead){
        //   console.log(this.user.letterhead);
        //   let canvas = document.getElementById("temp-canvas");
        //   canvas.src = this.user.letterhead.url
        // }
        // console.log("exhibit list: ", this.exhibitList);
        if (this.demandType === "STANDARD DEMAND") {
          this.demandLabel = "DEMAND";
        }
        pdfMake.fonts = {
          TimesRoman: {
            normal: "Times New Roman.ttf",
            bold: "Times New Roman Bold.ttf",
            italics: "Times New Roman Italic.ttf",
            bolditalics: "Times New Roman Bold Italic.ttf",
          },
          Roboto: {
            normal: "Roboto-Regular.ttf",
            bold: "Roboto-Medium.ttf",
            italics: "Roboto-Italic.ttf",
            bolditalics: "Roboto-MediumItalic.ttf",
          },
          Zapfino: {
            normal: "Zapfino.ttf",
          },
        };
        // let firm = this.matter.firms[0];
        let firm = this.selectedFirm;
        let personInsured = {};
        if(this.demandType === 'UIM POLICY LIMIT DEMAND'){
          personInsured = {
            text: `:   ${
              this.plaintiff
                ? this.plaintiff.fullName
                : "NONE PROVIDED"
            }`,
            bold: "true",
          }
        } else {
         personInsured = {
            text: `:   ${
              this.defendant
                ? this.defendant.fullName
                : "NONE PROVIDED"
            }`,
            bold: "true",
          }
        }



        ///======================LETTER HEAD EXPERIMENTAL==================
        let letterhead = {}
          if(this.matter.letterheadData){
            letterhead = {
            image: this.matter.letterheadData,
            width: 500
          };
        } else {
          letterhead = [[{
                      text: [
                        {
                          text: `${firm.firmName.toUpperCase()}\n`,
                          bold: true,
                          alignment: "center",
                          fontSize: 18,
                        },
                      ],
                    }],
                     [
                    {
                      text: [
                        {
                          text: `${firm.firmAddressLine.toUpperCase()}\n${firm.firmCityStateZip.toUpperCase()}\n`,
                          alignment: "center",
                          fontSize: 10,
                        },
                      ],
                    },
                  ],
                  [
                    {
                      text: [
                        {
                          text: `TELEPHONE: ${firm.firmPhone}\n FACSIMILE: ${firm.firmFax}\n\n`,
                          alignment: "center",
                          fontSize: 10,
                        },
                      ],
                    },
                  ],
                    ]
        }
       
        ///======================LETTER HEAD EXPERIMENTAL==================
        let deliveryPhrase = "";

        if (
          this.formOfDelivery.includes("mail") &&
          this.formOfDelivery.includes("email")
        ) {
          deliveryPhrase += `VIA FIRST CLASS MAIL and EMAIL to: ${
            this.recipientEmail || "pending"
          }`;
        } else if (
          this.formOfDelivery.includes("mail") &&
          !this.formOfDelivery.includes("email")
        ) {
          deliveryPhrase += "VIA FIRST CLASS MAIL";
        } else if (
          this.formOfDelivery.includes("email") &&
          !this.formOfDelivery.includes("mail")
        ) {
          deliveryPhrase += `VIA EMAIL to: ${this.recipientEmail || "pending"}`;
        }
        let insuranceRecipient;
        if (this.selectedProvider) {
          insuranceRecipient = [
            {
              text: [
                {
                  text: `\n`,
                },
                {
                  text: `${this.selectedProvider.name || "**"}\n`,
                },
                {
                  text: `${this.selectedProvider.streetAddress || "**"}\n`,
                },
                {
                  text: `${this.selectedProvider.cityStateZip || "**"}\n`,
                },
                {
                  text: `${this.selectedProvider.adjusterPhone || "**"}\n`,
                },
                {
                  text: `${this.selectedProvider.adjusterEmail || " "}\n`,
                },
              ],
            },
          ];
        } else {
          if(this.demandType !== 'UIM POLICY LIMIT DEMAND'){
            insuranceRecipient = [
              {
                text: [
                  {
                    text: `${this.defendantInsuranceName || "** PROVIDER NAME"}\n`,
                    preserveLeadingSpaces: true,
                  },

                  {
                    text: `${
                      this.defendantInsuranceStreetAddress ||
                      "** PROVIDER STREET ADDRESS 1"
                    }\n`,
                    preserveLeadingSpaces: true,
                  },

                  {
                    text: `${
                      this.defendantInsuranceCityStateZip ||
                      "** PROVIDER STREET ADDRESS 2"
                    }\n`,
                    preserveLeadingSpaces: true,
                  },

                  {
                    text: `${this.defendantInsuranceAdjusterPhone || ""}\n`,
                    preserveLeadingSpaces: true,
                  },

                  {
                    text: `${this.defendantInsuranceAdjusterEmail || ""}\n`,
                    preserveLeadingSpaces: true,
                  },
                ],
              },
            ];
          } else {
            insuranceRecipient = [
            {
              text: [
                {
                  text: `${this.plaintiffInsuranceName || "** PROVIDER NAME"}\n`,
                  preserveLeadingSpaces: true,
                },

                {
                  text: `${
                    this.plaintiffInsuranceStreetAddress ||
                    "** PROVIDER STREET ADDRESS 1"
                  }\n`,
                  preserveLeadingSpaces: true,
                },

                {
                  text: `${
                    this.plaintiffInsuranceCityStateZip ||
                    "** PROVIDER STREET ADDRESS 2"
                  }\n`,
                  preserveLeadingSpaces: true,
                },

                {
                  text: `${this.plaintiffInsuranceAdjusterPhone || ""}\n`,
                  preserveLeadingSpaces: true,
                },

                {
                  text: `${this.plaintiffInsuranceAdjusterEmail || ""}\n`,
                  preserveLeadingSpaces: true,
                },
              ],
            },
            ]
          }
          
        }

        let damageList = [];
        damageList.push([
                    {
                      text: [
                        {
                          text: `ECONOMIC DAMAGES\n`,
                          bold: true,
                          // alignment: "center",
                          decoration: "underline",
                        },
                      ],
                    },
                  ]);
        this.specificDamages.forEach((damage) => {
          if (!isNaN(damage.remainingBalance)) {
            if (
              damage.remainingBalance !== null &&
              damage.remainingBalance !== undefined
            ) {
              damageList.push({
                table: {
                  widths: ["*", 100],
                  body: [
                    [
                      [{ text: `${damage.providerName || "None Provided"}` }],
                      [
                        {
                          text: `$${damage.remainingBalance}`,
                          alignment: "right",
                        },
                      ],
                    ],
                  ],
                },
                // layout: "noBorders",
              });
            } else {
              damageList.push({
                table: {
                  widths: ["*", 100],
                  body: [
                    [
                      [{ text: `${damage.providerName || "None Provided"}` }],
                      [{ text: `$0`, alignment: "right" }],
                    ],
                  ],
                },
                // layout: "noBorders",
              });
            }
          } else {
            damageList.push({
              table: {
                widths: ["*", 100],
                body: [
                  [
                    [{ text: `${damage.providerName || "None Provided"}` }],
                    [{ text: `$0`, alignment: "right" }],
                  ],
                ],
              },
              // layout: "noBorders",
            });
          }
        });
        let specificDamagesDollars = new Intl.NumberFormat().format(
          this.totalRemainingBalance
        );
        damageList.push({
          table: {
            widths: ["*"],
            body: [
              [
                [
                  {
                    text: `TOTAL:   $${specificDamagesDollars}`,
                    alignment: "right",
                    bold: true,
                  },
                ],
              ],
            ],
          },
          layout: "noBorders",
        });
        
        if(this.demandType === 'UIM POLICY LIMIT DEMAND'){
          damageList = [];
        }
        let policyNumber;
        if (this.selectedProvider && this.selectedProvider.policyNumber) {
          policyNumber = this.selectedProvider.policyNumber;
        } else {
          policyNumber = this.defendantInsurancePolicyNumber;
        }
        let claimNumber;
        if (this.selectedProvider && this.selectedProvider.claimNumber) {
          claimNumber = this.selectedProvider.claimNumber;
        } else {
          claimNumber = this.defendantInsuranceClaimNumber;
        }

        let adjusterName;
        if (this.selectedProvider && this.selectedProvider.adjusterName) {
          adjusterName = this.selectedProvider.adjusterName;
        } else {
          adjusterName = this.defendantInsuranceAdjusterName;
        }

        let factList;
        if(this.demandType !== 'UIM POLICY LIMIT DEMAND'){
          factList = {
            ol: [],
          };
          this.factParagraphs.forEach((fact) => {
          factList.ol.push({ text: [{ text: `${fact}\n` }, { text: " " }] });
        });
          console.log("factList = ", factList);
          console.log("stats", this.statutes);
          console.log("caselaw", this.caseLaw);
          console.log("CODE", this.codeViolations);
        } else {
          factList = [];
        }
        // let factList = {
        //   ol: [],
        // };
       
        console.log("factList = ", factList);
        console.log("stats", this.statutes);
        console.log("caselaw", this.caseLaw);
        console.log("CODE", this.codeViolations);
        let liability = [];
        if (this.statutes) {
          this.statutes.forEach((stat) => {
            if (stat.citation === "Cal. Evid. Code § 669(a)") {
              liability.push(
                {
                  text: `${stat.citation} - ${stat.title}`,
                  bold: true,
                  // decoration: "underline",
                },
                [stat.paragraphs],
                { text: ` \n` }
              );
              if (this.codeViolations) {
                liability.push(
                  { text: `Code Violations: `, decoration: "underline" },
                  this.codeViolations,
                  { text: ` ` }
                );
              }
            } else {
              liability.push(
                {
                  text: `${stat.citation} - ${stat.title}`,
                  bold: true,
                  // decoration: "underline",
                },
                [stat.paragraphs],
                { text: ` ` }
              );
            }
          });
        }
        console.log("specific damages", this.specificDamages);
        let injurySummary = {
          ol: [],
        };

        this.injuries.forEach((injury) => {
          injurySummary.ol.push({
            text: `${injury.toUpperCase()}`,
          });
        });

        let injuryParagraph = [
          // { text: " " },

          [
            {
              text: [
                {
                  text: `SUMMARY OF INJURIES:\n`,
                  bold: true,
                  // alignment: "center",
                  decoration: "underline",
                },
              ],
            },
          ],
          [injurySummary],
          { text: " " },
        ];
        console.log("injuryParagraph", injuryParagraph);

        let totalLoe = 0;
        let finalTotalLoe = 0;
        let loeParagraph = [];

        if (this.lossOfEarnings.length > 0) {
          loeParagraph.push({
            text: [
              {
                text: `LOSS OF EARNINGS\n`,
                bold: true,
                // alignment: "center",
                decoration: "underline",
              },
            ],
          });
          this.lossOfEarnings.forEach((loe) => {
            totalLoe = totalLoe + parseFloat(loe.amount);
            loeParagraph.push({
              table: {
                widths: ["*", 100],
                body: [
                  [
                    [{ text: `${loe.description || "None Provided"}` }],
                    [{ text: `$${loe.amount}`, alignment: "right" }],
                  ],
                  // [{ text: `${loe.description || "None Provided"}` }],
                  // [{ text: `$${loe.amount}`, alignment: "right" }],
                ],
              },
              // layout: "noBorders",
            });
          });
          finalTotalLoe = parseFloat(totalLoe);
          let loeDollars = new Intl.NumberFormat().format(finalTotalLoe);
          loeParagraph.push(
            // [{ text: `TOTAL` }],
            [{ text: `TOTAL:    $${loeDollars}`, alignment: "right", bold: true }],
            [{ text: " " }]
          );
        }
        let qualityParagraph = [];
        let qualityList = {
          ol: [],
        };
        if (this.qualityOfLifeChanges.length > 0) {
          qualityParagraph.push({
            text: [
              {
                text: `QUALITY OF LIFE CHANGES\n`,
                bold: true,
                // alignment: "center",
                decoration: "underline",
              },
            ],
          });
          this.qualityOfLifeChanges.forEach((change) => {
            qualityList.ol.push({
              text: `${change.toUpperCase()}`,
            });
          });
          qualityParagraph.push([qualityList], [{ text: " " }]);
        }

        let nonEconomicDamages = [];
        if (this.selectedGenDamages.length > 0) {
          nonEconomicDamages.push([
            {
              text: [
                {
                  text: `NONECONOMIC DAMAGES\n`,
                  bold: true,
                  // alignment: "center",
                  decoration: "underline",
                },
              ],
            },
          ]);
          if (this.genDamCaseLaw) {
            this.genDamCaseLaw.forEach((law) => {
              nonEconomicDamages.push(
                {
                  text: [
                    { text: `${law.caseName}, `, italics: true },
                    { text: `${law.citation}.` },
                  ],
                  bold: true,
                  // decoration: "underline",
                },
                [law.paragraphs],
                { text: ` ` }
              );
            });
          }
        }
        // =================CONCLUSION======================

        let conclusionParagraph = [];
        if(this.demandType !== 'UIM POLICY LIMIT DEMAND'){
          conclusionParagraph.push([
          {
            text: [
              {
                text: `CONCLUSION\n`,
                bold: true,
                // alignment: "center",
                decoration: "underline",
              },
            ],
          },
        ]);

        if (this.demandType === "POLICY-LIMIT DEMAND") {
          conclusionParagraph.push([
            {
              text: [
                {
                  text: `As you are aware, trial is usually required in cases that do not settle at this stage. This case and the subsequent demand has been prepared with an assumption that the case will be tried before a jury. Therefore, we must impose a time limit for you to respond to our offer, which will include until ${this.docDueDate.toUpperCase()}.`,
                },
              ],
            },
            { text: ` ` },
            {
              text: [
                {
                  text: `If this case were brought to a jury verdict, it is very likely our client would receive a judgment against your insured substantially in excess of the limits of any policy of insurance on the subject vehicle.
                
                We will seek an award for damages for each of the following elements: 
                
                • Medical Expenses (past)
                • Medical Expenses (future)
                • Pain and Suffering (past)
                • Pain and Suffering (future)
                • Psychological Trauma &amp; Injury (past)
                • Psychological Trauma &amp; Injury (future)
                • Wage Loss (Future)`,
                },
              ],
            },
            { text: ` ` },
            {
              text: [
                {
                  text: `Accordingly, ${this.plaintiff.fullName.toUpperCase()} has authorized this firm to make a one time offer of settlement for the limits of your insured’s policy under the following conditions:

                  1. a)   In the event your insured’s policy is a per person/per accident policy, our client will settle his claim for bodily injury for the full amount of the per person policy limits of all of your insured’s polices. If the liability policy of your insured contains a liability deductible, self-retention amount, or other similar payment provision, this demand shall include payment of that amount in addition to the insurance limits (proceeds). If you decide to accept this offer, please provide our office with a copy of your insured’s policy declaration sheet to confirm the amount of the policy limits and conditions.

                      b)   In the event your insured’s policy limit is a combined single-limit policy, our client is willing to settle his claim for the full amount of the single-limit coverage. If the liability policy of your insured contains a liability deductible, self-retention amount or other similar payment provision, this demand shall include payment of the amount in addition to the insurance limits (proceeds). If you decide to accept this offer, please provide our office with a copy of your insured’s policy declaration sheet to confirm the amount of policy limits and conditions.

                      c)    In the event your insured has an applicable per-person polic(ies) along with a combined single-limit polic(ies), our client is willing to settle his claim for the full amount of the applicable limit coverages. If any of the liability policies of your insured contain a deductible, self-retention amount or other similar payment provision, this demand shall include payment of that amount in addition to the insurance limits (proceeds). If you choose to accept this offer, please provide our office with a copy of your insured’s policy declaration sheet(s) to confirm the amount of the policy limits and the conditions.

                  2.      The above offers are contingent on the tender of all of your insured’s applicable insurance coverage and policies for this accident.

                  3.     We will require a signed declaration from your insured stating whether he was in the course and scope of employment at the time of the collision

                  4.       Additionally, we will require a signed declaration from the defendant listing all insurance policies providing liability coverage to him, jointly and severally, at the time of the collision, whether it is presumed by you that coverage for this loss will or will not be afforded by those policies.

                    
                  Our offer of settlement will remain open for (${
                    this.timeLimit
                  }) days from the date of this letter and will not be renewed thereafter. In the event you fail to accept our offer of settlement within this period, we will proceed with litigation, and we will look to ${
                    this.defendantInsuranceName || `your insurance provider`
                  } to pay the entire judgment without regard to policy limits.


                  THIS POLICY LIMIT DEMAND WILL EXPIRE AT 5:00 P.M. ON ${this.docDueDate.toUpperCase()}. Thank you for your attention to this matter and we look forward to hearing from you. Please contact the undersigned as he continues to handle this case.
                    
                  This demand package and the information contained therein is given to you only for the purposes of further settlement discussion and case evaluation. It is not to be used by you in any way, without our express written permission.  It remains the property of the plaintiff and may not be copied or reproduced in any manner without the plaintiff's express written permission.  Furthermore, this information may in no way be used in the defense of this case as an admission against the plaintiff or against any interest of the plaintiff.

                  I thank you for your anticipated cooperation in the settlement of this matter and await your response. 
                `,
                },
              ],
            },
          ]);
        } else if (this.demandType === "STANDARD DEMAND") {
          conclusionParagraph.push([
            {
              text: [
                {
                  text: `From the above statement of facts, we feel there is no doubt we can establish a prima facie case for negligence against your insured. ${this.plaintiff.fullName.toUpperCase()}’s damages are clear, and our ability to prove a causal relationship is obvious. The pain and suffering will be demonstrated by not only my client’s testimony, but also by the testimony of treating physicians. Thus, without question, the decider of fact will be instructed to consider an award of damages for each of the following elements:
                
                • Medical Expenses (past)
                • Medical Expenses (future)
                • Pain and Suffering (past)
                • Pain and Suffering (future)
                • Psychological Trauma &amp; Injury (past)
                • Psychological Trauma &amp; Injury (future)
                • Wage Loss (Future)`,
                },

                {
                  text: `
                
                Based on the information provided herein, this letter demands settlement on behalf of my client in the amount of`,
                },
                { text: ` $${this.demandAmount || "*********"}`, bold: true },
                {
                  text: `. This amount is designed to adequately compensate my client for medical bills, future meds, inconvenience, pain and suffering and out-of-pocket expenses.
                
                This offer will remain open for ${
                  this.timeLimit
                } days from the date of this letter. THIS DEMAND WILL EXPIRE AT 5:00 P.M. ON ${this.docDueDate.toUpperCase()} after which time it will expire and be revoked.
                
                In the context of this case, we are certain you are mindful of your duty under section 790.3 (h)(5) of the California Insurance Code, which requires a good faith, prompt, fair and equitable settlement of this claim since liability is clear. Failure to accept an offer to settle this claim within policy limits could well expose your company to liability for excess judgment.
                
                If this claim is denied, we request pursuant to Section 790.03 (h)(13) of the California Insurance Code, a prompt and reasonable explanation in writing of the exact basis relied upon in relation to the facts or applicable law in making your decision.
                
                I thank you for your anticipated cooperation in the settlement of this matter and await your response.

                
                `,
                },
              ],
            },
          ]);
        } else {
          conclusionParagraph.push([
            {
              text: [
                {
                  text: `PLEASE SELECT A DEMAND TYPE AND AMOUNT `,
                  color: "red",
                },
              ],
            },
          ]);
        }
        } else {
          conclusionParagraph.push([
            {
              text: [
                {
                  text: `This demand for the policy limits (exclusive of and in addition to any medical payments available) on behalf of ${this.plaintiff.fullName} will expire ${this.timeLimit} days from the date of this correspondence. Thank you in advance for your timely consideration of this demand.`,
                },
              ],
            }
          ])
        }
        

        let signatureBody = {};
        if (
          this.selectedAttorney !== null &&
          this.selectedAttorney !== undefined
        ) {
          signatureBody = [
            { text: `Very truly yours,`, border: [false, false, false, false],},
            {
            // text: `\n\nBy:       /s/${this.selectedAttorney.toUpperCase()}/s/`,
            // text: `\n\nBy:       ${this.selectedAttorney}`,
            
            text: [
              // { text: `\n\nBy:` },
              {
                text: `    /s/${this.selectedAttorney.name}/s/`,
                preserveLeadingSpaces: true,
                font: "Zapfino",
              },
            ],
            alignment: "left",
            border: [false, false, false, true],
            // font: "Zapfino"
          }
          ];
        } else if (this.inputAttorney !== null && this.inputAttorney !== undefined){
          signatureBody = [
            { text: `Very truly yours,`, border: [false, false, false, false],},
            {
            // text: `\n\nBy:       /s/${this.selectedAttorney.toUpperCase()}/s/`,
            // text: `\n\nBy:       ${this.selectedAttorney}`,
            
            text: [
              // { text: `\n\nBy:` },
              {
                text: `    /s/${this.inputAttorney}/s/`,
                preserveLeadingSpaces: true,
                font: "Zapfino",
              },
            ],
            alignment: "left",
            border: [false, false, false, true],
            // font: "Zapfino"
          }
          ];
        } 
        else {
          signatureBody = [
            { text: `Very truly yours,`, border: [false, false, false, false],},
            {
            // text: `\n\nBy:       /s/${this.selectedAttorney.toUpperCase()}/s/`,
            // text: `\n\nBy:       ${this.selectedAttorney}`,
            
            text: [
              // { text: `\n\nBy:` },
              
              {
                text: `please select an attorney`,
                preserveLeadingSpaces: true,
                font: "Zapfino",
              },
            ],
            alignment: "center",
            border: [false, false, false, false],
            // font: "Zapfino"
          }
          ];
        }

        let exhibitParagraph = [];
        let exhibitParagraphList = {
          ol: [],
        };
        if (this.exhibitNames.length > 0) {
          exhibitParagraph.push({
            text: [
              {
                text: `EXHIBITS\n`,
                bold: true,
                // alignment: "center",
                decoration: "underline",
              },
            ],
          });

          this.exhibitNames.forEach((name) => {
            // let start = this.offset

            let index = this.exhibitNames.indexOf(name);
            // console.log("index", index);
            // let linkpage = this.exhibitPageLinks[index].pages - this.offset;
            // let linkpage = this.exhibitPageLinks[index].linkPage;

            // if (index !== 0) {
            //   this.offset += this.exhibitPageLinks[index].pages + 1;
            // }

            //let linkpage = this.offset;
            // console.log("linkpage", linkpage);
            exhibitParagraphList.ol.push({
              text: `${name.toUpperCase()}`,
              // linkToPage: linkpage,
            });
          });

          exhibitParagraph.push([exhibitParagraphList],[{ text: " " }]);
        }
        let factHeader = []
        if(this.demandType !== 'UIM POLICY LIMIT DEMAND'){
          factHeader = [{
            text: [
              {
                text: `FACTS:\n`,
                bold: true,
                // alignment: "center",
                decoration: "underline",
              },
            ],
          },
          [{ text: "" }]]
        }
        let liabilityHeader = []
        if(this.demandType !== 'UIM POLICY LIMIT DEMAND'){
          liabilityHeader = {
            text: [
              {
                text: `LAW AND LIABILITY:\n`,
                bold: true,
                // alignment: "center",
                decoration: "underline",
              },
            ],
          }
        }
        
        if(this.demandType == 'UIM POLICY LIMIT DEMAND'){
          injuryParagraph = []
        }
        
        let goodFaithParagraph = []
        if(this.demandType !== "UIM POLICY LIMIT DEMAND"){
          goodFaithParagraph.push(
                    [{
                      text: [
                        {
                          text: `DUTY OF GOOD FAITH AND FAIR DEALING:\n`,
                          bold: true,
                          // alignment: "center",
                          decoration: "underline",
                        },
                      ],
                    },
                    {
                      text: [
                        {
                          text: `With regard to the duty of an insurance company and adjustors to promptly investigate claims, and to make a prompt and reasonable attempt to settle such claims, the following is provided for your perusal:`,
                        },
                      ],
                    },
                    {
                      text: [
                        {
                          text: `“For the insurer to fulfill its obligation not to impair the right of the insured to receive the benefits of the agreement, it again must give at least as much consideration to the latter’s interests as it does to its own.” (Egan v. Mutual of Omaha Insurance Co. (1979) 24 Cal.3d 809, 818-819.)`,
                        },
                      ],
                    },
                  { text: " " },
                    {
                      text: [
                        {
                          text: `“ ‘[T]he covenant of good faith can be breached for objectively unreasonable conduct, regardless of the actor’s motive.’ . . . [A]n insured plaintiff need only show, for example, that the insurer unreasonably refused to pay benefits or failed to accept a reasonable settlement offer; there is no requirement to establish subjective bad faith.” (Bosetti v. United States Life Ins. Co. in the City of New York (2009) 175 Cal.App.4th 1208, 1236, original italics, internal citations omitted.)`,
                        },
                      ],
                    },
                  { text: " " },
                    {
                      text: [
                        {
                          text: `“ ‘[T]he covenant of good faith can be breached for objectively unreasonable conduct, regardless of the actor’s motive.’ . . . [A]n insured plaintiff need only show, for example, that the insurer unreasonably refused to pay benefits or failed to accept a reasonable settlement offer; there is no requirement to establish subjective bad faith.” (Bosetti v. United States Life Ins. Co. in the City of New York (2009) 175 Cal.App.4th 1208, 1236, original italics, internal citations omitted.)`,
                        },
                      ],
                    },
                  { text: " " },
                    {
                      text: [
                        {
                          text: `“[I]f the insurer denies benefits unreasonably (i.e., without any reasonable basis for such denial), it may be exposed to the full array of tort remedies, including possible punitive damages.” (Jordan v. Allstate Ins. Co. (2007) 148 Cal.App.4th1062, 1073.)`,
                        },
                      ],
                    },
                  { text: " " }]
          )
        }

        // let body = []
        // if(this.demandType !== 'UIM POLICY LIMIT DEMAND'){
        //   body.push(
                  
        //     [factHeader],
        //     [{ text: "" }],                  
        //     [factList],
        //     [{ text: "" }],
        //     [liabilityHeader],
        //     [liability],
        //     [injuryParagraph],
        //     [damageList],
        //     [loeParagraph],
        //     [{ text: " " }],
        //     [qualityParagraph],
        //     [{ text: " " }],
        //     [nonEconomicDamages],
        //     [{ text: " " }],
        //     [exhibitParagraph],
        //     [{ text: " " }],
        //     [goodFaithParagraph],
        //     [conclusionParagraph]
        //   )
        // } else {
        //   body.push([
        //     {
        //       text: [
        //         {
        //           text: `
        //             1) The adverse party's certified declaration page;
        //             2) A copy of the third-party settlement check;
        //             3) A copy of the signed third-party release; and 
        //             4) The demand letter to the third-party insurance that includes all available medical records and the
        //             grounds for our client¶s UIM demand.`,
        //           },
        //       ],
        //     }
        //   ])
        // }

        let uimDocList =[];
        if(this.demandType === 'UIM POLICY LIMIT DEMAND'){
          qualityParagraph = [];
          nonEconomicDamages = [];
          exhibitParagraph = [];
          goodFaithParagraph = [];
          uimDocList.push(
            {
              style: "tableExample",
              table: {
                widths: ["*"],
                body: [
                  // ["Column 1", "Column 2", "Column 3"],
                  // [],
                  [
                    [
                      {
                        style: "tableExample",
                        table: {
                          widths: [30, "*", 10],
                          body: [
                            // ["Column 1", "Column 2", "Column 3"],

                            [
                              [{ text: ``}],
                              [{ text: `1). The adverse party's certified declaration page`, bold: "true" }],
                              [],
                            ],
                            [
                              [{ text: ""}],
                              [{ text: "2). A copy of the third-party settlement check", bold: "true" }],
                              [],
                            ],
                            [
                              [{ text: ""}],
                              [{ text: "3). A copy of the signed third-party release; and", bold: "true" }],
                              [],
                            ],
                            [
                              [{ text: ""}],
                              [{ text: "4). The demand letter to the third-party insurance that includes all available medical records and the grounds for our client's UIM demand.", bold: "true" }],
                              [],
                            ]
                          ]
                        },
                        layout: "noBorders",
                      }
                    ]
                  ]
                ]
              },
              layout: "noBorders",
            }
          )
        }


      let docDef;
      if(this.demandType !== "UIM POLICY LIMIT DEMAND"){
        docDef = {
          content: [
            {
              table: {
                widths: ["*"],
                // dontBreakRows: true,
                body: [
                  // ["Column 1", "Column 2", "Column 3"],
                  // ["One value goes here", "Another one here", "OK?"],

                  // ======================LETTERHEAD==================
                  [letterhead],
                  [
                    {
                      text: [
                        {
                          text: `${this.demandDate.toUpperCase()}\n\n`,
                          alignment: "center",
                          fontSize: 12,
                        },
                      ],
                    },
                  ],

                  // ==================TITLE==================

                  [
                    {
                      text: [
                        {
                          text: `${this.docTitle}\n`,
                          alignment: "center",
                          decoration: "underline",
                          bold: true,
                          fontSize: 12,
                        },
                      ],
                    },
                  ],

                  // ==================DEMAND TYPE==================

                  [
                    {
                      text: [
                        {
                          text: `${this.demandType || this.demandLabel}\n`,
                          bold: true,
                          alignment: "center",
                          color: "red",
                        },
                      ],
                    },
                  ],

                  // ==================EXPRIRATION==================

                  [
                    {
                      text: [
                        {
                          text: `EXPIRATION: ${this.docDueDate.toUpperCase()}\n`,
                          bold: true,
                          alignment: "center",
                          color: "red",
                        },
                      ],
                    },
                  ],

                  // ==================DELIVERY TYPE==================
                  [
                    {
                      text: [
                        {
                          text: `${deliveryPhrase}`,
                          preserveLeadingSpaces: true,
                        },
                      ],
                    },
                  ],

                  // ===========================RECIPEINT==============

                  [insuranceRecipient],

                  // ===========================PARTY DETAILS==============
                  [
                    {
                      style: "tableExample",
                      table: {
                        widths: [100, "*"],
                        body: [
                          // ["Column 1", "Column 2", "Column 3"],
                          [
                            [],
                            // {
                            //   stack: [{ text: "RE: ", alignment: "right" }],
                            // },
                            [
                              {
                                style: "tableExample",
                                table: {
                                  widths: [30, 100, "*"],
                                  body: [
                                    // ["Column 1", "Column 2", "Column 3"],

                                    [
                                      [
                                        {
                                          text: "RE: ",
                                          alignment: "right",
                                          bold: "true",
                                        },
                                      ],
                                      [{ text: "Our Client", bold: "true" }],
                                      [
                                        {
                                          text: `:   ${this.plaintiff.fullName}`,
                                          bold: "true",
                                        },
                                      ],
                                    ],
                                    [
                                      [],
                                      [{ text: "Date Of Loss", bold: "true" }],
                                      [
                                        {
                                          text: `:   ${this.matter.dateOfLoss}`,
                                          bold: "true",
                                        },
                                      ],
                                    ],
                                    [
                                      [],
                                      [{ text: "Your Insured", bold: "true" }],
                                      [
                                        personInsured
                                      ],
                                    ],
                                    [
                                      [],
                                      [{ text: "Policy Number", bold: "true" }],
                                      [
                                        {
                                          text: `:   ${
                                            policyNumber || "NONE PROVIDED"
                                          }`,
                                          bold: "true",
                                        },
                                      ],
                                    ],
                                    [
                                      [],
                                      [{ text: "Claim Number", bold: "true" }],
                                      [
                                        {
                                          text: `:   ${
                                            claimNumber || "NONE PROVIDED"
                                          }`,
                                          bold: "true",
                                        },
                                      ],
                                    ],
                                  ],
                                },
                                layout: "noBorders",
                              },
                            ],
                          ],
                        ],
                      },
                      layout: "noBorders",
                    },
                  ],
                  // ==================END PARTY DETAILS==================

                  // ===========================INTRO==============

                  [`Dear ${adjusterName || "Adjuster"},\n`],
                                    [{ text: "" }],

                  [this.introParagraph],
                
                  //===========================FACTS==============
                  [factHeader],
                 
                  [factList],
                  // [{ text: "" }],
                  // ===========================LAW==============
                  [
                    liabilityHeader
                  ],
                  [liability],
                  //========================SUMMARY OF INJURIES =========

                  [injuryParagraph],
                 
                  [damageList],
                  // ===========================LOSS OF EARNINGS DAMAGES==============

                  [loeParagraph],
                  // ===========================QUALITY OF LIFE CHANGES==============
                  // [{ text: " " }],
                  [qualityParagraph],
                 
                  [nonEconomicDamages],
                  // ===========================EXHIBITS==============
                  // [{ text: " " }],
                  [exhibitParagraph],
                 

                  [goodFaithParagraph],
                  [uimDocList],
                  // ==============conclusion============
                  [conclusionParagraph],
                  [{ text: " " }],

                  [
                    {
                      table: {
                        dontBreakRows: true,
                        widths: [300, "*"],
                        body: [
                          // [
                          //   { text: `Very truly yours,`, border: [false, false, false, false] },
                          // ],
                          [
                            // { text: ` `, border: [false, false, false, false] },
                            // { text: `Very truly yours,`, border: [false, false, false, false] },

                            signatureBody,
                          ],

                          [
                            // { text: ` `, border: [false, false, false, false] },
                            {
                              text: `${firm.firmName.toUpperCase()}`,
                              alignment: "center",
                              border: [false, false, false, false],
                            },
                          ],
                        ],
                        fontSize: 12,  
                      }, 
                    },
                  ],
                ], //end body
              }, //end inner table
              layout: "noBorders",
            }, //end table
          ],
          footer: (currentPage) => {
            return [
              {
                table: {
                  widths: ["*"],
                  body: [
                    [
                      {
                        stack: [
                          {
                            text: `${currentPage.toString()}`,
                            alignment: "center",
                            fontSize: 9,
                          },
                          {
                            text: `${this.footerText.toUpperCase()}`,
                            alignment: "center",
                            fontSize: 8,
                          },
                        ],
                        layout: { defaultBorder: false },
                        border: [false, false, false, false],
                      },
                    ],
                  ],
                },
              },
            ];
          },
         
          pageMargins: [42, 42, 55, 40], //END CONENT SACK
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              margin: [0, 0, 0, 10],
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: [0, 10, 0, 5],
            },
            tableExample: {
              margin: [0, 0, 0, 0],
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: "black",
            },
          },
          defaultStyle: {
            // alignment: 'justify',
            font: "TimesRoman",
            fontSize: 12,
          },
          pageSize: "LETTER",
        };
      } else {
        docDef = {
          content: [
            {
              table: {
                widths: ["*"],
                // dontBreakRows: true,
                body: [
                  // ["Column 1", "Column 2", "Column 3"],
                  // ["One value goes here", "Another one here", "OK?"],

                  // ======================LETTERHEAD==================
                  [letterhead],
                  [
                    {
                      text: [
                        {
                          text: `${this.demandDate.toUpperCase()}\n\n`,
                          alignment: "center",
                          fontSize: 12,
                        },
                      ],
                    },
                  ],

                  // ==================TITLE==================

                  [
                    {
                      text: [
                        {
                          text: `${this.docTitle}\n`,
                          alignment: "center",
                          decoration: "underline",
                          bold: true,
                          fontSize: 12,
                        },
                      ],
                    },
                  ],

                  // ==================DEMAND TYPE==================

                  [
                    {
                      text: [
                        {
                          text: `${this.demandType || this.demandLabel}\n`,
                          bold: true,
                          alignment: "center",
                          color: "red",
                        },
                      ],
                    },
                  ],

                  // ==================EXPRIRATION==================

                  [
                    {
                      text: [
                        {
                          text: `EXPIRATION: ${this.docDueDate.toUpperCase()}\n`,
                          bold: true,
                          alignment: "center",
                          color: "red",
                        },
                      ],
                    },
                  ],

                  // ==================DELIVERY TYPE==================
                  [
                    {
                      text: [
                        {
                          text: `${deliveryPhrase}`,
                          preserveLeadingSpaces: true,
                        },
                      ],
                    },
                  ],

                  // ===========================RECIPEINT==============

                  [insuranceRecipient],

                  // ===========================PARTY DETAILS==============
                  [
                    {
                      style: "tableExample",
                      table: {
                        widths: [100, "*"],
                        body: [
                          // ["Column 1", "Column 2", "Column 3"],
                          [
                            [],
                            // {
                            //   stack: [{ text: "RE: ", alignment: "right" }],
                            // },
                            [
                              {
                                style: "tableExample",
                                table: {
                                  widths: [30, 100, "*"],
                                  body: [
                                    // ["Column 1", "Column 2", "Column 3"],

                                    [
                                      [
                                        {
                                          text: "RE: ",
                                          alignment: "right",
                                          bold: "true",
                                        },
                                      ],
                                      [{ text: "Our Client", bold: "true" }],
                                      [
                                        {
                                          text: `:   ${this.plaintiff.fullName}`,
                                          bold: "true",
                                        },
                                      ],
                                    ],
                                    [
                                      [],
                                      [{ text: "Date Of Loss", bold: "true" }],
                                      [
                                        {
                                          text: `:   ${this.matter.dateOfLoss}`,
                                          bold: "true",
                                        },
                                      ],
                                    ],
                                    [
                                      [],
                                      [{ text: "Your Insured", bold: "true" }],
                                      [
                                        personInsured
                                      ],
                                    ],
                                    [
                                      [],
                                      [{ text: "Policy Number", bold: "true" }],
                                      [
                                        {
                                          text: `:   ${
                                            policyNumber || "NONE PROVIDED"
                                          }`,
                                          bold: "true",
                                        },
                                      ],
                                    ],
                                    [
                                      [],
                                      [{ text: "Claim Number", bold: "true" }],
                                      [
                                        {
                                          text: `:   ${
                                            claimNumber || "NONE PROVIDED"
                                          }`,
                                          bold: "true",
                                        },
                                      ],
                                    ],
                                  ],
                                },
                                layout: "noBorders",
                              },
                            ],
                          ],
                        ],
                      },
                      layout: "noBorders",
                    },
                  ],
                  // ==================END PARTY DETAILS==================

                  // ===========================INTRO==============

                  [`Dear ${adjusterName || "Adjuster"},\n`],
                                    [{ text: "" }],

                  [this.introParagraph],
                
                  [uimDocList],
                  // ==============conclusion============
                  [conclusionParagraph],
                  [{ text: " " }],

                  [
                    {
                      table: {
                        dontBreakRows: true,
                        widths: [300, "*"],
                        body: [
                          
                          [signatureBody],

                          [
                            {
                              text: `${firm.firmName.toUpperCase()}`,
                              alignment: "center",
                              border: [false, false, false, false],
                            },
                          ],
                        ],
                        fontSize: 12,  
                      }, 
                    },
                  ],
                ], //end body
              }, //end inner table
              layout: "noBorders",
            }, //end table
          ],
          footer: (currentPage) => {
            return [
              {
                table: {
                  widths: ["*"],
                  body: [
                    [
                      {
                        stack: [
                          {
                            text: `${currentPage.toString()}`,
                            alignment: "center",
                            fontSize: 9,
                          },
                          {
                            text: `${this.footerText.toUpperCase()}`,
                            alignment: "center",
                            fontSize: 8,
                          },
                        ],
                        layout: { defaultBorder: false },
                        border: [false, false, false, false],
                      },
                    ],
                  ],
                },
              },
            ];
          },
         
          pageMargins: [42, 42, 55, 40], //END CONENT SACK
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              margin: [0, 0, 0, 10],
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: [0, 10, 0, 5],
            },
            tableExample: {
              margin: [0, 0, 0, 0],
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: "black",
            },
          },
          defaultStyle: {
            // alignment: 'justify',
            font: "TimesRoman",
            fontSize: 12,
          },
          pageSize: "LETTER",
        };
      }
        
        this.doc = pdfMake.createPdf(docDef);
        this.doc.getDataUrl((url) => {
          this.iframeSrc = url;
        });

        if (this.exhibitList.length > 0) {
          this.overlay = true
          console.log("overlay")
          this.doc.getBuffer((buffer) => {
            (async () => {
              this.testDocBuffer = buffer;
              const demandPDF = await PDFDocument.load(this.testDocBuffer);

              return demandPDF;
              // let finalBytes = await demandPDF.save();
              // this.finalPDF = await URL.createObjectURL(
              //   new Blob([finalBytes], {
              //     type: "application/pdf",
              //   })
              // );
              // await window.open(this.finalPDF, "_blank");
            })().then((demandPDF) => {
              (async () => {
                let exhibitCount = 0;
                let pageNumber = 0;
                for (let exhibit of this.exhibitList) {
                  //add an object to data that includes

                  //the batesNumber where this exhibit starts

                  //the name of the exhibit

                  //maybe a description of the

                  //add this to a link item in the docdef... how to do this...
                  //I must do this in onFileUpload

                  let exhibitBuffer = await exhibit.arrayBuffer();
                  // await console.log(exhibitBuffer);

                  // let exhibitPDF = await PDFDocument.create();
                  let exhibitPDF = await PDFDocument.load(exhibitBuffer);

                  exhibitCount++;
                  let cover = await demandPDF.addPage(PageSizes.Letter);
                  await cover.drawText(`Exhibit ${exhibitCount}`, {
                    x: 175,
                    y: 415,
                  });

                  let prefix = `${this.prefix}`;
                  await pageNumber++;
                  let zeros;
                  if (pageNumber < 10) {
                    zeros = await `000000`;
                  } else if (pageNumber >= 10 && pageNumber < 100) {
                    zeros = await `00000`;
                  } else if (pageNumber >= 100 && pageNumber < 1000) {
                    zeros = await `0000`;
                  } else if (pageNumber >= 1000 && pageNumber < 10000) {
                    zeros = await `000`;
                  } else if (pageNumber >= 10000 && pageNumber < 100000) {
                    zeros = await `00`;
                  }

                  let helveticaFont = await demandPDF.embedFont(
                    StandardFonts.Helvetica
                  );

                  // let firstPage = await exhibitPages[0];
                  let { width, height } = await cover.getSize();
                  await cover.drawText(`${prefix} - ${zeros}${pageNumber}`, {
                    // x: 5,
                    x: width - width / 4,
                    // y: height / 2 + 300,
                    y: height / 20 - 35,
                    size: 12,
                    font: helveticaFont,
                    // color: rgb(0.95, 0.1, 0.1),
                    // rotate: degrees()
                  });
                  let exhibitPages = await exhibitPDF.getPages();
                  for (let exhibitPage of exhibitPages) {
                    // let index = await exhibitPages.indexOf(exhibitPage);
                    // await console.log("index", index);
                    await pageNumber++;

                    // console.log("exhibitNumber:", exhibitCount);
                    // console.log("exhibitPage:", exhibitPage);
                    // console.log("pageNumber:", pageNumber);
                    let embeddedPage = await demandPDF.embedPage(exhibitPage);
                    let scaledEmbed = await embeddedPage.scale(0.92);
                    let page = await demandPDF.addPage(PageSizes.Letter);

                    await page.drawPage(embeddedPage, {
                      ...scaledEmbed,
                      x: page.getWidth() / 2 - scaledEmbed.width / 2,
                      y: page.getHeight() / 2 - scaledEmbed.height / 2,
                    });

                    let prefix = `${this.prefix}`;

                    let zeros;
                    if (pageNumber < 10) {
                      zeros = await `000000`;
                    } else if (pageNumber >= 10 && pageNumber < 100) {
                      zeros = await `00000`;
                    } else if (pageNumber >= 100 && pageNumber < 1000) {
                      zeros = await `0000`;
                    } else if (pageNumber >= 1000 && pageNumber < 10000) {
                      zeros = await `000`;
                    } else if (pageNumber >= 10000 && pageNumber < 100000) {
                      zeros = await `00`;
                    }

                    let helveticaFont = await demandPDF.embedFont(
                      StandardFonts.Helvetica
                    );

                    let firstPage = await exhibitPages[0];
                    let { width, height } = await firstPage.getSize();
                    await page.drawText(`${prefix} - ${zeros}${pageNumber}`, {
                      // x: 5,
                      x: width - width / 4,
                      // y: height / 2 + 300,
                      y: height / 20 - 35,
                      size: 12,
                      font: helveticaFont,
                      // color: rgb(0.95, 0.1, 0.1),
                      // rotate: degrees()
                    });

                    // // await console.log("doing something here after all that");
                    // // await console.log("saving final PDF");
                    // let finalBytes = await demandPDF.save();
                    // this.finalPDF = await URL.createObjectURL(
                    //   new Blob([finalBytes], {
                    //     type: "application/pdf",
                    //   })
                    // );
                  }
                  await console.log("doing something here after all that");
                  await console.log("saving final PDF");
                  let finalBytes = await demandPDF.save();
                  this.finalBytes = await finalBytes;
                  this.finalPDF = await URL.createObjectURL(
                    new Blob([finalBytes], {
                      type: "application/pdf",
                    })
                  );
                } 
                
              })().then(()=>{
                this.overlay = false;
                console.log("overlay OFF")
              });
            });
          });
          // this.overlay = false
          // // ++++++++++++++++++++++++++++++++++++++++
          // this.doc.getBuffer((buffer) => {
          //   (async () => {
          //     this.testDocBuffer = buffer;
          //     const demandPDF = await PDFDocument.load(this.testDocBuffer);

          //     return demandPDF;
          //     // let finalBytes = await demandPDF.save();
          //     // this.finalPDF = await URL.createObjectURL(
          //     //   new Blob([finalBytes], {
          //     //     type: "application/pdf",
          //     //   })
          //     // );
          //     // await window.open(this.finalPDF, "_blank");
          //   })().then((demandPDF) => {
          //     (async () => {
          //       let demandPages = await demandPDF.getPages();
          //       await console.log("demandPages", demandPages);
          //       let exhibitCount = 0;
          //       let pageNumber = 0;
          //       this.exhibitList.forEach((exhibit) => {
          //         (async () => {
          //           let exhibitBuffer = await exhibit.arrayBuffer();
          //           await console.log(exhibitBuffer);

          //           // let exhibitPDF = await PDFDocument.create();
          //           let exhibitPDF = await PDFDocument.load(exhibitBuffer);

          //           exhibitCount++;
          //           let cover = await demandPDF.addPage(PageSizes.Letter);
          //           await cover.drawText(`Exhibit ${exhibitCount}`, {
          //             x: 135,
          //             y: 415,
          //           });
          //           pageNumber++;

          //           let prefix = `DEMAND`;
          //           await pageNumber++;
          //           let zeros;
          //           if (pageNumber < 10) {
          //             zeros = await `000000`;
          //           } else if (pageNumber >= 10 && pageNumber < 100) {
          //             zeros = await `00000`;
          //           } else if (pageNumber >= 100 && pageNumber < 1000) {
          //             zeros = await `0000`;
          //           } else if (pageNumber >= 1000 && pageNumber < 10000) {
          //             zeros = await `000`;
          //           } else if (pageNumber >= 10000 && pageNumber < 100000) {
          //             zeros = await `00`;
          //           }

          //           let helveticaFont = await demandPDF.embedFont(
          //             StandardFonts.Helvetica
          //           );

          //           // let firstPage = await exhibitPages[0];
          //           let { width, height } = await cover.getSize();
          //           await cover.drawText(`${prefix} - ${zeros}${pageNumber}`, {
          //             // x: 5,
          //             x: width - width / 4,
          //             // y: height / 2 + 300,
          //             y: height / 20 - 35,
          //             size: 12,
          //             font: helveticaFont,
          //             color: rgb(0.95, 0.1, 0.1),
          //             // rotate: degrees()
          //           });
          //           let exhibitPages = await exhibitPDF.getPages();
          //           await exhibitPages.forEach((exhibitPage) => {
          //             (async () => {
          //               let index = await exhibitPages.indexOf(exhibitPage);
          //               await console.log("index", index);
          //               await pageNumber++;

          //               console.log("exhibitNumber:", exhibitCount);
          //               // console.log("exhibitPage:", exhibitPage);
          //               console.log("pageNumber:", pageNumber);
          //               let embeddedPage = await demandPDF.embedPage(exhibitPage);
          //               let scaledEmbed = await embeddedPage.scale(0.95);
          //               let page = await demandPDF.addPage(PageSizes.Letter);

          //               await page.drawPage(embeddedPage, {
          //                 ...scaledEmbed,
          //                 x: page.getWidth() / 2 - scaledEmbed.width / 2,
          //                 y: page.getHeight() / 2 - scaledEmbed.height / 2,
          //               });

          //               let prefix = await `DEMAND`;

          //               let zeros;
          //               if (pageNumber < 10) {
          //                 zeros = await `000000`;
          //               } else if (pageNumber >= 10 && pageNumber < 100) {
          //                 zeros = await `00000`;
          //               } else if (pageNumber >= 100 && pageNumber < 1000) {
          //                 zeros = await `0000`;
          //               } else if (pageNumber >= 1000 && pageNumber < 10000) {
          //                 zeros = await `000`;
          //               } else if (pageNumber >= 10000 && pageNumber < 100000) {
          //                 zeros = await `00`;
          //               }

          //               let helveticaFont = await demandPDF.embedFont(
          //                 StandardFonts.Helvetica
          //               );

          //               let firstPage = await exhibitPages[0];
          //               let { width, height } = await firstPage.getSize();
          //               await page.drawText(`${prefix} - ${zeros}${pageNumber}`, {
          //                 // x: 5,
          //                 x: width - width / 4,
          //                 // y: height / 2 + 300,
          //                 y: height / 20 - 35,
          //                 size: 12,
          //                 font: helveticaFont,
          //                 color: rgb(0.95, 0.1, 0.1),
          //                 // rotate: degrees()
          //               });

          //               await console.log("doing something here after all that");
          //               await console.log("saving final PDF");
          //               let finalBytes = await demandPDF.save();
          //               this.finalPDF = await URL.createObjectURL(
          //                 new Blob([finalBytes], {
          //                   type: "application/pdf",
          //                 })
          //               );
          //               // await window.open(this.finalPDF, "_blank");
          //             })();
          //           });

          //           // let indeces = exhibitPDF.getPageIndices();

          //           // let embeddedPDF = demandPDF.embedPages()

          //           //  let exhibitPages = exhibitPDF.getPages();
          //           // exhibitPages.forEach(exhibitPage => {
          //           //   demandPDF.embedPages
          //           // })
          //         })();
          //       });
          //       return demandPDF;
          //     })();
          //     // .then((demandPDF) => {
          //     //   (async () => {
          //     //     await console.log("doing something here after all that");
          //     //     await console.log("saving final PDF");
          //     //     let finalBytes = await demandPDF.save();
          //     //     this.finalPDF = await URL.createObjectURL(
          //     //       new Blob([finalBytes], {
          //     //         type: "application/pdf",
          //     //       })
          //     //     );
          //     //     await window.open(this.finalPDF, "_blank");
          //     //   })();
          //     // });
          //   });
          //   // .then((demandPDF) => {
          //   //   (async () => {
          //   //     await console.log("doing something here after all that");
          //   //     await console.log("saving final PDF");
          //   //     let finalBytes = await demandPDF.save();
          //   //     this.finalPDF = await URL.createObjectURL(
          //   //       new Blob([finalBytes], {
          //   //         type: "application/pdf",
          //   //       })
          //   //     );
          //   //     await window.open(this.finalPDF, "_blank");
          //   //   })();
          //   // });

          //   // (async () => {
          //   //   this.testDocBuffer = buffer;
          //   //   await console.log(this.testDocBuffer);
          //   //   //create a new pdf with pdf-lib
          //   //   // const mergedPDF = await PDFDocument.create();

          //   //   //loading pdf we just created with pdfMake as an array buffer
          //   //   await console.log(
          //   //     "loading the demand document buffer to generatedPDF"
          //   //   );
          //   //   const generatedPDF = await PDFDocument.load(this.testDocBuffer);

          //   //   //load each exhibit from exhibitList using pdf-lib

          //   //   let exhibitCount = 0;
          //   //   let pageNumber = 0;

          //   //   await this.exhibitList.forEach((exh) => {
          //   //     (async () => {
          //   //       await exhibitCount++;
          //   //       await console.log("exhibit count: ", exhibitCount);
          //   //       await this.exhibitNames.push(`${exh.name}`);
          //   //       await console.log("exhibit names: ", this.exhibitNames);
          //   //       //get buffer for the exhibit file loaded by user
          //   //       await console.log("getting buffer of exhbit file");
          //   //       let exhibitBuffer = await exh.arrayBuffer();
          //   //       //load a PDFDocument from the uploaded exhibit
          //   //       await console.log("loading the exhibit buffer to loadedPDF");
          //   //       let loadedPDF = await PDFDocument.load(exhibitBuffer);
          //   //       //now we create a new pdf that the attachement will be embedded into scaled at 95%
          //   //       await console.log(
          //   //         "creating a new PDF for the exhibit called attachmentPDF"
          //   //       );
          //   //       let attachmentPDF = await PDFDocument.create();

          //   //       //add a cover page to the exhibit PDF
          //   //       await console.log("adding cover page to attachmentPDF");
          //   //       let cover = await attachmentPDF.addPage(PageSizes.Letter);
          //   //       cover.drawText(`Exhibit ${exhibitCount}`, { x: 135, y: 415 });

          //   //       //get the loadedPDF pages
          //   //       let loadedPages = await loadedPDF.getPages();

          //   //       await loadedPages.forEach((loadedPage) => {
          //   //         //async function to embed each page at .95 scale
          //   //         (async () => {
          //   //           await pageNumber++;
          //   //           await console.log("page number of exhibit: ", pageNumber);
          //   //           await console.log(
          //   //             "embedding page of exhibit to attachmentPDF"
          //   //           );
          //   //           let embeddedPage = await attachmentPDF.embedPage(
          //   //             loadedPage
          //   //           );
          //   //           await console.log("scaling embedded page page of exhibit");
          //   //           let scaledEmbed = await embeddedPage.scale(0.95);
          //   //           await console.log("adding a page to attachmentPDF");
          //   //           let attachmentPage = await attachmentPDF.addPage(
          //   //             PageSizes.Letter
          //   //           );
          //   //           await console.log(
          //   //             "drawing scaledEmbed page of exhibit to the attachemntPage we just added to attachmentPDF"
          //   //           );
          //   //           await attachmentPage.drawPage(embeddedPage, {
          //   //             ...scaledEmbed,
          //   //             x: attachmentPage.getWidth() / 2 - scaledEmbed.width / 2,
          //   //             y:
          //   //               attachmentPage.getHeight() / 2 - scaledEmbed.height / 2,
          //   //           });
          //   //           await console.log("embedding font Helvetica");
          //   //           const helveticaFont = await attachmentPDF.embedFont(
          //   //             StandardFonts.Helvetica
          //   //           );
          //   //           await console.log("getting attachmentPDF pages");
          //   //           let pages = await attachmentPDF.getPages();

          //   //           let firstPage = pages[0];
          //   //           let { width, height } = await firstPage.getSize();

          //   //           await pages.forEach((attachmentPage) => {
          //   //             let prefix = `DEMAND`;
          //   //             let zeros;
          //   //             if (pageNumber < 10) {
          //   //               zeros = `000000`;
          //   //             } else if (pageNumber >= 10 && pageNumber < 100) {
          //   //               zeros = `00000`;
          //   //             } else if (pageNumber >= 100 && pageNumber < 1000) {
          //   //               zeros = `0000`;
          //   //             } else if (pageNumber >= 1000 && pageNumber < 10000) {
          //   //               zeros = `000`;
          //   //             } else if (pageNumber >= 10000 && pageNumber < 100000) {
          //   //               zeros = `00`;
          //   //             }
          //   //             console.log("drawing batesNumber");
          //   //             attachmentPage.drawText(
          //   //               `${prefix} - ${zeros}${pageNumber}`,
          //   //               {
          //   //                 x: width - width / 4,
          //   //                 y: height / 20 - 35,
          //   //                 size: 12,
          //   //                 font: helveticaFont,
          //   //                 color: rgb(0.95, 0.1, 0.1),
          //   //               }
          //   //             );
          //   //           });
          //   //           await console.log("saving attachmentPDF to bytes");
          //   //           let attachmentBytes = await attachmentPDF.save();
          //   //           //attach the scaled and stamped pdf to the generated pdf
          //   //           await console.log("attaching exhibit to generatedPDF");
          //   //           await generatedPDF.attach(attachmentBytes, `${exh.name}`, {
          //   //             mimeType: "application/pdf",
          //   //             description: `${exh.name}`,
          //   //           });
          //   //           await console.log("saving generatedPDF to bytes");
          //   //           const finalPdfBytes = await generatedPDF.save();
          //   //           await console.log(
          //   //             "creating object URL and saving to this.finalPDF to open in new window"
          //   //           );
          //   //           this.finalPDF = await URL.createObjectURL(
          //   //             new Blob([finalPdfBytes], {
          //   //               type: "application/pdf",
          //   //             })
          //   //           );
          //   //           return window.open(this.finalPDF, "_blank");
          //   //         })();
          //   //       });

          //   //       // await console.log("saving attachmentPDF to bytes");
          //   //       // let attachmentBytes = await attachmentPDF.save();
          //   //       // //attach the scaled and stamped pdf to the generated pdf
          //   //       // await console.log("attaching exhibit to generatedPDF");
          //   //       // await generatedPDF.attach(attachmentBytes, `${exh.name}`, {
          //   //       //   mimeType: "application/pdf",
          //   //       //   description: `${exh.name}`,
          //   //       // });
          //   //       // await console.log("saving generatedPDF to bytes");
          //   //       // const finalPdfBytes = await generatedPDF.save();
          //   //       // await console.log(
          //   //       //   "creating object URL and saving to this.finalPDF to open in new window"
          //   //       // );
          //   //       // this.finalPDF = await URL.createObjectURL(
          //   //       //   new Blob([finalPdfBytes], {
          //   //       //     type: "application/pdf",
          //   //       //   })
          //   //       // );
          //   //       // return window.open(this.finalPDF, "_blank");
          //   //     })();
          //   //   });
          //   // })();
          // });
        } else {
          this.overlay = false;
          console.log("OVERLAY OFF")
        }
      
    },
  },
  created() {
    //get plaintiff
    firebase
      .firestore()
      .collection("matters")
      .doc(this.$route.params.id)
      .collection("clients")
      .doc(this.$route.params.client)
      .onSnapshot((doc) => {
        this.tempPlaintiff = doc.data();
        if (
          this.tempPlaintiff.demands !== null &&
          this.tempPlaintiff.demands !== undefined
        ) {
        //   // alert("this plaintiff has a demand already");
        //   //get a list of prior demands 
        //   //push the list to data
        this.priorDemands = this.tempPlaintiff.demands
       
          
        }
        //  else {
        //   console.log(
        //     "this plaintiff does not have a demand",
        //     this.tempPlaintiff
        //   );
        // }
      });

    //get matter
    //and get formList for this plaintiff
    firebase
      .firestore()
      .collection("matters")
      .doc(this.$route.params.id)
      .onSnapshot((doc) => {
        this.matter = doc.data();
        // let formList;
        if (this.tempPlaintiff) {
          let p = this.matter.plaintiffs.find(
            (plaintiff) => plaintiff.partySlug === this.tempPlaintiff.clientSlug
          );
          this.plaintiff = { ...p, ...this.tempPlaintiff };
          if (p !== undefined && p !== null) {
            this.formList = p.formList;
            console.log("complete Plaintiff", this.plaintiff);
          } else {
            this.formList = "UNDEFINED";
          }
        } else {
          console.log("theres no plaintiff yet");
        }
      });
    pdfMake.fonts = {
      Roboto: {
        normal: "Roboto-Regular.ttf",
        bold: "Roboto-Medium.ttf",
        italics: "Roboto-Italic.ttf",
        bolditalics: "Roboto-MediumItalic.ttf",
      },
    };
    let docDef = {
      content: ["LOADING >>>"],
    };

    this.doc = pdfMake.createPdf(docDef);
    this.doc.getDataUrl((url) => {
      this.iframeSrc = url;
    });
    //getFirm
  },
};
</script>

<style>
</style>